// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import PhoneInput from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import {
//   FaUser,
//   FaEnvelope,
//   FaLock,
//   FaEye,
//   FaEyeSlash,
//   FaArrowLeft,
// } from "react-icons/fa";
// import axios from "axios";
// import VetLearnLogo from "../Images/Kaas 4.png"; // Ensure this path is correct
// import RegisterImage from "../Images/TestLogin.png"; // Ensure this path is correct
// import LoginImage from "../Images/TestLogin.png"; // Ensure this path is correct
// import { motion, AnimatePresence } from "framer-motion";
// import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
// import Lottie from "react-lottie";

// // Vetrina Theme Colors
// const VETRINA_PURPLE = "#B8529E";
// const VETRINA_ORANGE = "#FF6600";
// const VETRINA_TEXT_PRIMARY = "#333";
// const VETRINA_TEXT_SECONDARY = "#555";
// const VETRINA_BACKGROUND_LIGHT = "#f8f9fa";
// const VETRINA_ACCENT_LIGHT_PURPLE = "#ede7f6";
// const VETRINA_DARK_PURPLE_ACCENT = "#7D52A0";

// // API Configuration
// const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com/";
// const GOOGLE_CLIENT_ID =
//   "563227117215-cvm1hposi4qtk3kcrb3693vsq8osefts.apps.googleusercontent.com";

// // Lottie Animation for Initial Load
// const loadingAnimationData = {
//   v: "5.5.7",
//   fr: 30,
//   ip: 0,
//   op: 60,
//   w: 100,
//   h: 100,
//   nm: "Loading",
//   ddd: 0,
//   assets: [],
//   layers: [
//     {
//       ddd: 0,
//       ind: 1,
//       ty: 4,
//       nm: "Circle",
//       sr: 1,
//       ks: {
//         o: { a: 0, k: 100 },
//         r: {
//           a: 1,
//           k: [
//             { t: 0, s: [0], e: [360] },
//             { t: 60, s: [360], e: [720] },
//           ],
//         },
//         p: { a: 0, k: [50, 50, 0] },
//         a: { a: 0, k: [0, 0, 0] },
//         s: { a: 0, k: [100, 100, 100] },
//       },
//       ao: 0,
//       shapes: [
//         {
//           ty: "gr",
//           it: [
//             {
//               d: 1,
//               ty: "el",
//               s: { a: 0, k: [40, 40] },
//               p: { a: 0, k: [0, 0] },
//               nm: "Ellipse Path 1",
//             },
//             {
//               ty: "st",
//               c: { a: 0, k: [0.72, 0.32, 0.62, 1] },
//               o: { a: 0, k: 100 },
//               w: { a: 0, k: 6 },
//               lc: 2,
//               lj: 1,
//               ml: 4,
//               bm: 0,
//               nm: "Stroke 1",
//             },
//             {
//               ty: "tr",
//               p: { a: 0, k: [0, 0] },
//               a: { a: 0, k: [0, 0] },
//               s: { a: 0, k: [100, 100] },
//               r: { a: 0, k: 0 },
//               o: { a: 0, k: 100 },
//               nm: "Transform",
//             },
//           ],
//           nm: "Ellipse 1",
//         },
//       ],
//       ip: 0,
//       op: 60,
//       st: 0,
//       bm: 0,
//     },
//   ],
// };
// const defaultLottieOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: loadingAnimationData,
//   rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
// };

// // Header Height Constant
// const HEADER_HEIGHT = "60px";

// // Common Styles - Adjusted for better UI, prioritizing readability & touch targets
// const formControlStyle = {
//   border: "1px solid #ced4da",
//   padding: "8px 12px",
//   height: "40px",
//   borderRadius: "8px",
//   fontSize: "0.9rem",
// };
// const inputGroupTextStyle = {
//   backgroundColor: VETRINA_ACCENT_LIGHT_PURPLE,
//   border: `1px solid ${VETRINA_PURPLE}`,
//   borderRight: "none",
//   color: VETRINA_PURPLE,
//   borderTopLeftRadius: "8px",
//   borderBottomLeftRadius: "8px",
//   padding: "0 12px",
//   display: "flex",
//   alignItems: "center",
//   minWidth: "45px",
//   height: "40px", // Ensure consistent height with form controls
// };
// const inputGroupControlStyle = {
//   ...formControlStyle,
//   borderTopLeftRadius: "0",
//   borderBottomLeftRadius: "0",
//   borderLeft: "none",
//   height: "40px", // Ensure consistent height
// };
// const phoneInputStyle = {
//   // These styles are now largely handled by the global CSS,
//   // but kept as a reference for consistency if inputComponent changes
//   width: "100%",
//   height: "40px",
//   padding: "8px 12px",
//   border: "1px solid #ced4da",
//   borderRadius: "8px",
//   fontSize: "0.9rem",
// };
// const formLabelStyle = {
//   // Only used in ForgotPasswordPage
//   fontWeight: "500",
//   color: VETRINA_TEXT_SECONDARY,
//   marginBottom: "5px",
//   fontSize: "0.85rem",
// };
// const submitButtonStyle = {
//   background: `linear-gradient(45deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE})`,
//   borderColor: "transparent",
//   fontSize: "1rem",
//   padding: "10px",
//   marginTop: "10px",
//   marginBottom: "15px",
//   height: "42px",
//   borderRadius: "20px",
//   fontWeight: "bold",
//   boxShadow: `0 4px 15px rgba(184, 82, 158, 0.3)`,
//   width: "100%",
//   transition: "all 0.3s ease",
// };
// const submitButtonDisabledStyle = {
//   ...submitButtonStyle,
//   background: VETRINA_DARK_PURPLE_ACCENT,
//   cursor: "default",
// };

// const LoginForm = ({
//   toggleView,
//   onGoogleSuccess,
//   apiBaseUrl,
//   themeColors,
//   commonStyles,
// }) => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isErr, setIsErr] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);

//   useEffect(() => {
//     const savedEmail = localStorage.getItem("savedEmail");
//     if (savedEmail) {
//       setEmail(savedEmail);
//       setRememberMe(true);
//     }
//   }, []);

//   const loginUser = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setIsErr(false);
//     try {
//       const response = await axios.post(`${apiBaseUrl}auth/login/`, {
//         email,
//         password,
//       });
//       if (response.data && response.status === 200) {
//         if (rememberMe) localStorage.setItem("savedEmail", email);
//         else localStorage.removeItem("savedEmail");
//         localStorage.setItem("jwttoken", response.data.access);
//         const role = response.data.role;
//         if (role) localStorage.setItem("role", role);
//         const roleMapper = {
//           Client: "/result",
//           Trainer: "/result",
//           Instructor: "/Home",
//           // Student: "/Home", // Student also goes to Home
//           Admin: "/lmsadmindashboard",
//         };
//         const targetPath = roleMapper[role] || "/Home"; // Default to /Home if role not explicitly mapped
//         let swalTitle = "Success!";
//         let swalHtml = `<p style="color: ${themeColors.VETRINA_TEXT_PRIMARY};">You have logged in successfully.</p>`;
//         if (role === "Student") {
//           swalTitle = "Welcome Back!";
//           swalHtml = `<div style="text-align: center; padding: 10px;"><h2 style="color: ${themeColors.VETRINA_PURPLE}; margin-bottom: 15px; font-size: 1.5em;">Ready to Learn?</h2><p style="font-size: 1.1em; color: ${themeColors.VETRINA_TEXT_SECONDARY}; line-height: 1.6;">Your journey to knowledge continues here!</p></div>`;
//         }
//         Swal.fire({
//           title: swalTitle,
//           html: swalHtml,
//           icon: "success",
//           background: VETRINA_BACKGROUND_LIGHT,
//           confirmButtonColor: themeColors.VETRINA_PURPLE,
//           timer: swalHtml.includes("Ready to Learn?") ? 3500 : 1500,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         }).then(() => navigate(targetPath));
//       }
//     } catch (error) {
//       const errMessage =
//         error.response?.data?.error ||
//         error.response?.data?.detail ||
//         "Invalid Credentials or server error.";
//       Swal.fire({
//         title: "Login Failed!",
//         text: errMessage,
//         icon: "error",
//         background: VETRINA_BACKGROUND_LIGHT,
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//         confirmButtonText: "Try Again",
//       });
//       setIsErr(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Form onSubmit={loginUser}>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           <InputGroup.Text
//             style={{
//               ...commonStyles.inputGroupTextStyle,
//               borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE,
//             }}
//           >
//             <FaEnvelope />
//           </InputGroup.Text>
//           <Form.Control
//             type="email"
//             placeholder="Email Address"
//             value={email}
//             onChange={(e) => {
//               setIsErr(false);
//               setEmail(e.target.value);
//             }}
//             required
//             style={{
//               ...commonStyles.inputGroupControlStyle,
//               borderColor: isErr ? "#e74c3c" : "#ced4da",
//             }}
//           />
//         </InputGroup>
//       </Form.Group>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           <InputGroup.Text
//             style={{
//               ...commonStyles.inputGroupTextStyle,
//               borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE,
//             }}
//           >
//             <FaLock />
//           </InputGroup.Text>
//           <Form.Control
//             type={showPassword ? "text" : "password"}
//             placeholder="Password"
//             value={password}
//             onChange={(e) => {
//               setIsErr(false);
//               setPassword(e.target.value);
//             }}
//             required
//             style={{
//               ...commonStyles.inputGroupControlStyle,
//               borderRight: "none",
//               borderColor: isErr ? "#e74c3c" : "#ced4da",
//             }}
//           />
//           <Button
//             onClick={() => setShowPassword(!showPassword)}
//             variant="outline-secondary"
//             style={{
//               height: commonStyles.inputGroupControlStyle.height,
//               borderColor: "#ced4da",
//               borderLeft: "none",
//               borderTopRightRadius: "8px",
//               borderBottomRightRadius: "8px",
//               color: themeColors.VETRINA_PURPLE,
//               padding: "0 12px",
//             }}
//           >
//             {showPassword ? <FaEyeSlash /> : <FaEye />}
//           </Button>
//         </InputGroup>
//       </Form.Group>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "15px",
//           marginTop: "5px",
//         }}
//       >
//         <Form.Check
//           type="checkbox"
//           id="rememberMe"
//           label="Remember me"
//           checked={rememberMe}
//           onChange={(e) => setRememberMe(e.target.checked)}
//           style={{
//             fontSize: "0.8rem",
//             color: themeColors.VETRINA_TEXT_SECONDARY,
//           }}
//         />
//         <a
//           href="#!"
//           onClick={(e) => {
//             e.preventDefault();
//             navigate("/reset-password");
//           }}
//           style={{
//             color: themeColors.VETRINA_PURPLE,
//             textDecoration: "none",
//             fontSize: "0.8rem",
//             fontWeight: "500",
//           }}
//           onMouseOver={(e) =>
//             (e.target.style.color = themeColors.VETRINA_ORANGE)
//           }
//           onMouseOut={(e) =>
//             (e.target.style.color = themeColors.VETRINA_PURPLE)
//           }
//         >
//           Forgot Password?
//         </a>
//       </div>
//       <Button
//         type="submit"
//         disabled={loading}
//         style={
//           loading
//             ? commonStyles.submitButtonDisabledStyle
//             : commonStyles.submitButtonStyle
//         }
//       >
//         {loading ? (
//           <>
//             <span
//               className="spinner-border spinner-border-sm"
//               style={{ marginRight: "8px" }}
//             ></span>
//             Signing In...
//           </>
//         ) : (
//           "Sign In"
//         )}
//       </Button>
//       <div
//         style={{ textAlign: "center", margin: "15px 0", position: "relative" }}
//       >
//         <hr style={{ backgroundColor: "#e0e0e0" }} />
//         <span
//           style={{
//             position: "absolute",
//             top: "-10px",
//             backgroundColor: "white",
//             padding: "0 8px",
//             color: themeColors.VETRINA_TEXT_SECONDARY,
//             left: "50%",
//             transform: "translateX(-50%)",
//             fontSize: "0.8rem",
//           }}
//         >
//           OR
//         </span>
//       </div>
//       <motion.div
//         initial={{ y: 20, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ delay: 0.2, duration: 0.5 }}
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           marginBottom: "15px",
//         }}
//       >
//         <GoogleLogin
//           onSuccess={onGoogleSuccess}
//           onError={(error) =>
//             Swal.fire({
//               title: "Error!",
//               text: error.message || "Google sign-in failed",
//               icon: "error",
//               confirmButtonColor: themeColors.VETRINA_ORANGE,
//             })
//           }
//           theme="outline"
//           size="medium"
//           text="signin_with"
//           shape="pill"
//           logo_alignment="center"
//         />
//       </motion.div>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: "15px",
//           fontSize: "0.85rem",
//           color: themeColors.VETRINA_TEXT_PRIMARY,
//         }}
//       >
//         New to VetLearn?{" "}
//         <a
//           href="#!"
//           onClick={(e) => {
//             e.preventDefault();
//             toggleView();
//           }}
//           style={{
//             color: themeColors.VETRINA_PURPLE,
//             textDecoration: "none",
//             fontWeight: "bold",
//           }}
//           onMouseOver={(e) =>
//             (e.target.style.color = themeColors.VETRINA_ORANGE)
//           }
//           onMouseOut={(e) =>
//             (e.target.style.color = themeColors.VETRINA_PURPLE)
//           }
//         >
//           Create Account
//         </a>
//       </p>
//     </Form>
//   );
// };

// const RegisterForm = ({
//   toggleView,
//   onGoogleSuccess,
//   apiBaseUrl,
//   themeColors,
//   commonStyles,
// }) => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     confirmPassword: "",
//     otp: "",
//   });
//   const [emailError, setEmailError] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [showOTPField, setShowOTPField] = useState(false);
//   const [isEmailVerifiedStepDone, setIsEmailVerifiedStepDone] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((p) => ({ ...p, [name]: value }));
//     if (name === "email") validateEmail(value);
//     if (name === "confirmPassword") validatePasswords(formData.password, value);
//     if (name === "password") validatePasswords(value, formData.confirmPassword);
//   };
//   const validateEmail = (email) => {
//     /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email)
//       ? setEmailError("")
//       : setEmailError("Invalid email format.");
//   };
//   const validatePasswords = (pw, cpw) => {
//     cpw && pw !== cpw
//       ? setPasswordError("Passwords do not match.")
//       : setPasswordError("");
//   };
//   const handlePhoneChange = (value) =>
//     setFormData((p) => ({ ...p, phoneNumber: value }));

//   const sendOTP = () => {
//     if (!formData.email || emailError) {
//       Swal.fire({
//         title: "Error",
//         text: "Valid email required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return;
//     }
//     setOtpLoading(true);
//     axios
//       .post(`${apiBaseUrl}auth/verify-email/`, { email: formData.email })
//       .then(() => {
//         Swal.fire({
//           title: "OTP Sent",
//           text: "Check email for OTP.",
//           icon: "success",
//           confirmButtonColor: themeColors.VETRINA_PURPLE,
//         });
//         setShowOTPField(true);
//         setIsEmailVerifiedStepDone(true);
//       })
//       .catch(() =>
//         Swal.fire({
//           title: "Error",
//           text: "Failed to send OTP.",
//           icon: "error",
//           confirmButtonColor: themeColors.VETRINA_ORANGE,
//         })
//       )
//       .finally(() => setOtpLoading(false));
//   };

//   const validateFullForm = () => {
//     const {
//       firstName,
//       lastName,
//       phoneNumber,
//       email,
//       password,
//       confirmPassword,
//       otp,
//     } = formData;
//     if (!firstName || !lastName) {
//       Swal.fire({
//         text: "Names required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (!phoneNumber) {
//       Swal.fire({
//         text: "Phone required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (emailError || !email) {
//       Swal.fire({
//         text: "Valid email required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (password.length < 6) {
//       Swal.fire({
//         text: "Password min 6 chars.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (password !== confirmPassword) {
//       Swal.fire({
//         text: "Passwords do not match.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (!isEmailVerifiedStepDone) {
//       Swal.fire({
//         text: "Verify email first.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (showOTPField && !otp) {
//       Swal.fire({
//         text: "OTP required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateFullForm()) return;
//     setLoading(true);
//     axios
//       .post(`${apiBaseUrl}auth/signup/`, {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         mobile_number: formData.phoneNumber,
//         otp: Number.parseInt(formData.otp),
//       })
//       .then(() => {
//         Swal.fire({
//           title: "Success!",
//           text: "Account created! Please log in.",
//           icon: "success",
//           confirmButtonColor: themeColors.VETRINA_PURPLE,
//         });
//         toggleView();
//       })
//       .catch((err) => {
//         const msg =
//           err.response?.data?.detail ||
//           err.response?.data?.email?.[0] ||
//           err.response?.data?.mobile_number?.[0] ||
//           "Registration failed.";
//         Swal.fire({
//           title: "Error",
//           text: msg,
//           icon: "error",
//           confirmButtonColor: themeColors.VETRINA_ORANGE,
//         });
//       })
//       .finally(() => setLoading(false));
//   };

//   return (
//     <Form onSubmit={handleSubmit}>
//       <Row>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaUser />
//               </InputGroup.Text>
//               <Form.Control
//                 type="text"
//                 name="firstName"
//                 placeholder="First Name"
//                 value={formData.firstName}
//                 onChange={handleChange}
//                 required
//                 style={commonStyles.inputGroupControlStyle}
//               />
//             </InputGroup>
//           </Form.Group>
//         </Col>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaUser />
//               </InputGroup.Text>
//               <Form.Control
//                 type="text"
//                 name="lastName"
//                 placeholder="Last Name"
//                 value={formData.lastName}
//                 onChange={handleChange}
//                 required
//                 style={commonStyles.inputGroupControlStyle}
//               />
//             </InputGroup>
//           </Form.Group>
//         </Col>
//       </Row>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//             <FaEnvelope />
//           </InputGroup.Text>
//           <Form.Control
//             type="email"
//             name="email"
//             placeholder="Email Address"
//             value={formData.email}
//             onChange={handleChange}
//             isInvalid={!!emailError}
//             required
//             style={{
//               ...commonStyles.inputGroupControlStyle,
//               borderRight: "none",
//             }}
//           />
//           <Button
//             onClick={sendOTP}
//             disabled={otpLoading || !formData.email || !!emailError}
//             style={{
//               backgroundColor: themeColors.VETRINA_PURPLE,
//               borderColor: themeColors.VETRINA_PURPLE,
//               height: commonStyles.inputGroupControlStyle.height,
//               borderTopRightRadius: "8px",
//               borderBottomRightRadius: "8px",
//               borderTopLeftRadius: "0",
//               borderBottomLeftRadius: "0",
//               fontSize: commonStyles.inputGroupControlStyle.fontSize,
//               padding: "0 12px",
//             }}
//           >
//             {otpLoading ? (
//               <>
//                 <span
//                   className="spinner-border spinner-border-sm"
//                   style={{ marginRight: "5px" }}
//                 ></span>
//                 Sending
//               </>
//             ) : (
//               "Verify"
//             )}
//           </Button>
//           {emailError && (
//             <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
//               {emailError}
//             </Form.Control.Feedback>
//           )}
//         </InputGroup>
//       </Form.Group>
//       <Form.Group className="mb-3">
//         <InputGroup>

//         {/* PhoneInput now uses its own internal styling for compactness */}
//         <PhoneInput
//           international
//           defaultCountry="IN"
//           value={formData.phoneNumber}
//           onChange={handlePhoneChange}
//           inputComponent={Form.Control} // This just makes it render a Bootstrap Form.Control
//           inputProps={{
//             name: "phoneNumber",
//             required: true,
//             placeholder: "Phone Number",
//           }}
//         />
//         </InputGroup>
//       </Form.Group>
//       <Row>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaLock />
//               </InputGroup.Text>
//               <Form.Control
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 placeholder="Password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   ...commonStyles.inputGroupControlStyle,
//                   borderRight: "none",
//                 }}
//               />
//               <Button
//                 onClick={() => setShowPassword(!showPassword)}
//                 variant="outline-secondary"
//                 style={{
//                   height: commonStyles.inputGroupControlStyle.height,
//                   borderColor: "#ced4da",
//                   borderLeft: "none",
//                   borderTopRightRadius: "8px",
//                   borderBottomRightRadius: "8px",
//                   color: themeColors.VETRINA_PURPLE,
//                   padding: "0 12px",
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </Button>
//             </InputGroup>
//           </Form.Group>
//         </Col>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaLock />
//               </InputGroup.Text>
//               <Form.Control
//                 type={showConfirmPassword ? "text" : "password"}
//                 name="confirmPassword"
//                 placeholder="Confirm Password"
//                 value={formData.confirmPassword}
//                 onChange={handleChange}
//                 isInvalid={!!passwordError}
//                 required
//                 style={{
//                   ...commonStyles.inputGroupControlStyle,
//                   borderRight: "none",
//                 }}
//               />
//               <Button
//                 onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                 variant="outline-secondary"
//                 style={{
//                   height: commonStyles.inputGroupControlStyle.height,
//                   borderColor: "#ced4da",
//                   borderLeft: "none",
//                   borderTopRightRadius: "8px",
//                   borderBottomRightRadius: "8px",
//                   color: themeColors.VETRINA_PURPLE,
//                   padding: "0 12px",
//                 }}
//               >
//                 {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//               </Button>
//               {passwordError && (
//                 <Form.Control.Feedback
//                   type="invalid"
//                   style={{ display: "block" }}
//                 >
//                   {passwordError}
//                 </Form.Control.Feedback>
//               )}
//             </InputGroup>
//           </Form.Group>
//         </Col>
//       </Row>
//       {showOTPField && (
//         <motion.div
//           initial={{ opacity: 0, height: 0 }}
//           animate={{ opacity: 1, height: "auto" }}
//           transition={{ duration: 0.3 }}
//         >
//           <Form.Group className="mb-3">
//             <Form.Control
//               type="text"
//               name="otp"
//               value={formData.otp}
//               onChange={handleChange}
//               required
//               style={commonStyles.formControlStyle}
//               placeholder="Enter OTP"
//             />
//           </Form.Group>
//         </motion.div>
//       )}
//       <Button
//   type="submit"
//   disabled={loading}
//   style={{
//     width: "150px", // or any desired small width
//     padding: "8px 12px", // adjust for smaller button feel
//     fontSize: "0.9rem",
//     ...(
//       loading
//         ? commonStyles.submitButtonDisabledStyle
//         : commonStyles.submitButtonStyle
//     )
//   }}
// >
//   {loading ? (
//     <>
//       <span
//         className="spinner-border spinner-border-sm"
//         style={{ marginRight: "8px" }}
//       ></span>
//       Creating...
//     </>
//   ) : (
//     "Sign Up"
//   )}
// </Button>

//       <div
//         style={{ textAlign: "center", margin: "15px 0", position: "relative" }}
//       >
//         <hr style={{ backgroundColor: "#e0e0e0" }} />
//         <span
//           style={{
//             position: "absolute",
//             top: "-10px",
//             backgroundColor: "white",
//             padding: "0 8px",
//             color: themeColors.VETRINA_TEXT_SECONDARY,
//             left: "50%",
//             transform: "translateX(-50%)",
//             fontSize: "0.8rem",
//           }}
//         >
//           OR
//         </span>
//       </div>
//       <motion.div
//         initial={{ y: 20, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ delay: 0.2, duration: 0.5 }}
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           marginBottom: "15px",
//         }}
//       >
//         <GoogleLogin
//           onSuccess={onGoogleSuccess}
//           onError={(error) =>
//             Swal.fire({
//               title: "Error!",
//               text: error.message || "Google sign-up failed",
//               icon: "error",
//               confirmButtonColor: VETRINA_ORANGE,
//             })
//           }
//           theme="outline"
//           size="medium"
//           text="signup_with"
//           shape="pill"
//           logo_alignment="center"
//         />
//       </motion.div>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: "15px",
//           fontSize: "0.85rem",
//           color: themeColors.VETRINA_TEXT_PRIMARY,
//         }}
//       >
//         Already have an account?{" "}
//         <a
//           href="#!"
//           onClick={(e) => {
//             e.preventDefault();
//             toggleView();
//           }}
//           style={{
//             color: themeColors.VETRINA_PURPLE,
//             textDecoration: "none",
//             fontWeight: "bold",
//           }}
//           onMouseOver={(e) =>
//             (e.target.style.color = themeColors.VETRINA_ORANGE)
//           }
//           onMouseOut={(e) =>
//             (e.target.style.color = themeColors.VETRINA_PURPLE)
//           }
//         >
//           Sign In
//         </a>
//       </p>
//     </Form>
//   );
// };

// // ForgotPasswordPage remains unchanged from the previous iteration, retaining its own distinct sizing for a larger, simpler form.
// export const ForgotPasswordPage = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);

//   const themeColors = {
//     VETRINA_PURPLE,
//     VETRINA_ORANGE,
//     VETRINA_TEXT_PRIMARY,
//     VETRINA_TEXT_SECONDARY,
//     VETRINA_BACKGROUND_LIGHT,
//     VETRINA_ACCENT_LIGHT_PURPLE,
//     VETRINA_DARK_PURPLE_ACCENT,
//   };
//   // This page retains its own slightly larger styles for clarity, separate from AuthPage
//   const localCommonStyles = {
//     formControlStyle: {
//       ...formControlStyle,
//       height: "40px",
//       padding: "8px 12px",
//       fontSize: "0.9rem",
//       borderRadius: "8px",
//     },
//     inputGroupTextStyle: {
//       ...inputGroupTextStyle,
//       height: "40px",
//       minWidth: "45px",
//       padding: "0 12px",
//       borderRadius: "8px",
//     },
//     inputGroupControlStyle: {
//       ...inputGroupControlStyle,
//       height: "40px",
//       padding: "8px 12px",
//       fontSize: "0.9rem",
//       borderRadius: "8px",
//     },
//     formLabelStyle: {
//       ...formLabelStyle,
//       fontSize: "0.85rem",
//       marginBottom: "5px",
//     },
//     submitButtonStyle: {
//       ...submitButtonStyle,
//       height: "42px",
//       padding: "10px",
//       fontSize: "1rem",
//       borderRadius: "20px",
//     },
//     submitButtonDisabledStyle: {
//       ...submitButtonDisabledStyle,
//       height: "42px",
//       padding: "10px",
//       fontSize: "1rem",
//       borderRadius: "20px",
//     },
//   };

//   const handleResetPasswordRequest = async (e) => {
//     e.preventDefault();
//     if (!email) {
//       Swal.fire({
//         text: "Email address is required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//         background: VETRINA_BACKGROUND_LIGHT,
//         customClass: { popup: "swal-custom-popup" },
//       });
//       return;
//     }
//     setLoading(true);
//     try {
//       await axios.post(`${API_BASE_URL}auth/forgot-password/`, { email });
//       Swal.fire({
//         title: "Instructions Sent!",
//         html: `<p style="color: ${themeColors.VETRINA_TEXT_SECONDARY};">If an account with that email exists, password reset instructions have been sent. Please check your inbox (and spam folder).</p>`,
//         icon: "success",
//         confirmButtonColor: themeColors.VETRINA_PURPLE,
//         background: VETRINA_BACKGROUND_LIGHT,
//         customClass: { popup: "swal-custom-popup" },
//       }).then(() => {
//         setEmail("");
//       });
//     } catch (error) {
//       Swal.fire({
//         title: "Request Processed",
//         html: `<p style="color: ${themeColors.VETRINA_TEXT_SECONDARY};">If an account with that email exists, instructions have been sent. If you don't receive an email, please check your spam folder or try again later.</p>`,
//         icon: "info",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//         background: VETRINA_BACKGROUND_LIGHT,
//         customClass: { popup: "swal-custom-popup" },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         background: `linear-gradient(135deg, ${themeColors.VETRINA_ACCENT_LIGHT_PURPLE}99 0%, #e9eaf7AA 100%)`,
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "30px 15px",
//         fontFamily: "'Poppins', sans-serif",
//       }}
//     >
//       <Container>
//         <Row className="justify-content-center">
//           <Col md={8} lg={6} xl={5}>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//               style={{
//                 backgroundColor: "rgba(255, 255, 255, 0.98)",
//                 borderRadius: "20px",
//                 padding: "30px 25px",
//                 boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
//                 border: "1px solid rgba(255,255,255,0.3)",
//               }}
//             >
//               <div style={{ textAlign: "center", marginBottom: "25px" }}>
//                 <img
//                   src={VetLearnLogo}
//                   alt="VetLearn Logo"
//                   onClick={() => navigate("/")}
//                   style={{
//                     height: "65px",
//                     marginBottom: "15px",
//                     cursor: "pointer",
//                   }}
//                 />
//                 <h2
//                   style={{
//                     color: themeColors.VETRINA_PURPLE,
//                     fontWeight: "bold",
//                     fontSize: "1.7rem",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   Forgot Password?
//                 </h2>
//                 <p
//                   style={{
//                     color: themeColors.VETRINA_TEXT_SECONDARY,
//                     fontSize: "0.9rem",
//                     lineHeight: "1.5",
//                   }}
//                 >
//                   Enter your email address below. If it's associated with an
//                   account, we'll send you instructions to reset your password.
//                 </p>
//               </div>
//               <Form onSubmit={handleResetPasswordRequest}>
//                 <Form.Group className="mb-4">
//                   <Form.Label style={localCommonStyles.formLabelStyle}>
//                     Email Address
//                   </Form.Label>
//                   <InputGroup>
//                     <InputGroup.Text
//                       style={localCommonStyles.inputGroupTextStyle}
//                     >
//                       <FaEnvelope />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type="email"
//                       placeholder="Enter your registered email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       required
//                       style={localCommonStyles.inputGroupControlStyle}
//                     />
//                   </InputGroup>
//                 </Form.Group>
//                 <Button
//                   type="submit"
//                   disabled={loading}
//                   style={
//                     loading
//                       ? localCommonStyles.submitButtonDisabledStyle
//                       : localCommonStyles.submitButtonStyle
//                   }
//                 >
//                   {loading ? (
//                     <>
//                       <span
//                         className="spinner-border spinner-border-sm"
//                         style={{ marginRight: "8px" }}
//                       ></span>
//                       Sending...
//                     </>
//                   ) : (
//                     "Send Reset Link"
//                   )}
//                 </Button>
//               </Form>
//               <div style={{ textAlign: "center", marginTop: "25px" }}>
//                 <Button
//                   variant="link"
//                   onClick={() => navigate(-1)}
//                   style={{
//                     color: themeColors.VETRINA_PURPLE,
//                     textDecoration: "none",
//                     fontWeight: "500",
//                     fontSize: "0.9rem",
//                   }}
//                   onMouseOver={(e) =>
//                     (e.target.style.color = themeColors.VETRINA_ORANGE)
//                   }
//                   onMouseOut={(e) =>
//                     (e.target.style.color = themeColors.VETRINA_PURPLE)
//                   }
//                 >
//                   <FaArrowLeft style={{ marginRight: "5px" }} /> Back to Sign In
//                 </Button>
//               </div>
//             </motion.div>
//           </Col>
//         </Row>
//       </Container>
//       {/* This style block was moved to AuthPage for global SweetAlert consistency */}
//     </div>
//   );
// };

// const AuthPage = () => {
//   const [isLoginView, setIsLoginView] = useState(true);
//   const [initialLoading, setInitialLoading] = useState(true);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => setInitialLoading(false), 1200);
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => {
//       clearTimeout(timer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const toggleView = useCallback(() => setIsLoginView((prev) => !prev), []);

//   const handleGoogleAuthSuccess = async (credentialResponse) => {
//     const token = credentialResponse.credential;
//     Swal.fire({
//       title: "Processing Google Sign-In...",
//       didOpen: () => Swal.showLoading(),
//       allowOutsideClick: false,
//       confirmButtonColor: VETRINA_PURPLE,
//       background: VETRINA_BACKGROUND_LIGHT,
//     });
//     try {
//       const response = await axios.post(`${API_BASE_URL}auth/google/login/`, {
//         token,
//       });
//       localStorage.setItem("jwttoken", response.data.access);
//       Swal.close();
//       Swal.fire({
//         title: "Success!",
//         text: "Signed in with Google successfully!",
//         icon: "success",
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//         confirmButtonColor: VETRINA_PURPLE,
//         background: VETRINA_BACKGROUND_LIGHT,
//       }).then(() => navigate("/Home"));
//     } catch (error) {
//       Swal.close();
//       Swal.fire({
//         title: "Error!",
//         text: error.response?.data?.error || "Google sign-in failed.",
//         icon: "error",
//         confirmButtonColor: VETRINA_ORANGE,
//         background: VETRINA_BACKGROUND_LIGHT,
//       });
//     }
//   };

//   const isMobile = windowWidth < 992;

//   if (initialLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//           background: `linear-gradient(135deg, ${VETRINA_ACCENT_LIGHT_PURPLE} 0%, #f0f2f5 100%)`,
//         }}
//       >
//         <Lottie options={defaultLottieOptions} height={120} width={120} />
//         <h3
//           style={{
//             marginTop: 20,
//             color: VETRINA_PURPLE,
//             fontFamily: "'Poppins', sans-serif",
//             fontWeight: "bold",
//           }}
//         >
//           Loading VetLearn...
//         </h3>
//       </div>
//     );
//   }

//   return (
//     <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
//       {/* This is the main page container div */}
//       <div
//         style={{
//           background: "white", // Overall page background is white
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           fontFamily: "'Poppins', sans-serif",
//           position: "relative",
//           overflow: "hidden", // Important for preventing horizontal scroll from background blobs/elements
//         }}
//       >
//         {/* NEW HEADER */}
//         <header
//           style={{
//             height: HEADER_HEIGHT,
//             backgroundColor: "white",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "0 20px",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//             zIndex: 100,
//             zIndex: 1000, // Increased z-index to ensure it's always on top
//             position: "fixed", // Make the header fixed
//             top: 0,
//             left: 0,
//             right: 0,
//           }}
//         >
//           <div style={{ flexShrink: 0 }}>
//             {/* Left side: Logo */}
//             <img
//               src={VetLearnLogo} // Use VetLearnLogo directly
//               alt="VetLearn Logo"
//               onClick={() => navigate("/")}
//               style={{
//                 height: "40px",
//                 cursor: "pointer",
//                 filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))",
//               }}
//             />
//           </div>
//           <div style={{ flexGrow: 1, textAlign: "center" }}>
//             <motion.h1
//               initial={{ opacity: 0, scale: 0.8 }}
//               animate={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.5, ease: "easeOut" }}
//               style={{
//                 fontSize: "1.8rem",
//                 fontWeight: "bold",
//                 background: `linear-gradient(to right, #f4811ee5, ${VETRINA_PURPLE})`,
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 backgroundClip: "text",
//                 color: "transparent",
//                 display: "inline-block",
//                 margin: "0",
//                 filter: "drop-shadow(1px 1px 2px rgba(0,0,0,0.1))",
//               }}
//             >
//               VetLearn Hub
//             </motion.h1>
//           </div>

//     <div style={{ display: "flex", gap: "15px", flexShrink: 0 }}>
//       {/* Desktop: Show both buttons */}
//       {!isMobile && (
//         <>
//           <Button
//             variant="link"
//             onClick={() => setIsLoginView(true)}
//             style={{
//               color: isLoginView ? VETRINA_PURPLE : VETRINA_TEXT_SECONDARY,
//               fontWeight: isLoginView ? "bold" : "normal",
//               textDecoration: "none",
//               fontSize: "0.95rem",
//               borderBottom: isLoginView ? `2px solid ${VETRINA_PURPLE}` : "none",
//               paddingBottom: "5px",
//               transition: "all 0.3s ease",
//             }}
//             onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
//             onMouseOut={(e) =>
//               (e.target.style.color = isLoginView ? VETRINA_PURPLE : VETRINA_TEXT_SECONDARY)
//             }
//           >
//             Sign In
//           </Button>
//           <Button
//             variant="link"
//             onClick={() => setIsLoginView(false)}
//             style={{
//               color: !isLoginView ? VETRINA_PURPLE : VETRINA_TEXT_SECONDARY,
//               fontWeight: !isLoginView ? "bold" : "normal",
//               textDecoration: "none",
//               fontSize: "0.95rem",
//               borderBottom: !isLoginView ? `2px solid ${VETRINA_PURPLE}` : "none",
//               paddingBottom: "5px",
//               transition: "all 0.3s ease",
//             }}
//             onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
//             onMouseOut={(e) =>
//               (e.target.style.color = !isLoginView ? VETRINA_PURPLE : VETRINA_TEXT_SECONDARY)
//             }
//           >
//             Sign Up
//           </Button>
//         </>
//       )}

//       {/* Mobile: Show only one toggle button */}
//       {isMobile && (
//         <Button
//           variant="link"
//           onClick={() => setIsLoginView(!isLoginView)}
//           style={{
//             color: VETRINA_PURPLE,
//             fontWeight: "bold",
//             textDecoration: "none",
//             fontSize: "1rem",
//             borderBottom: `2px solid ${VETRINA_PURPLE}`,
//             paddingBottom: "5px",
//             transition: "all 0.3s ease",
//           }}
//           onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
//           onMouseOut={(e) => (e.target.style.color = VETRINA_PURPLE)}
//         >
//           {isLoginView ? "Sign Up" : "Sign In"}
//         </Button>
//       )}
//     </div>

//         </header>

//         {/* Main Content Area */}
//         <Container
//           fluid
//           style={{
//             flexGrow: 1,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: "0px", // Main container padding
//             paddingTop: HEADER_HEIGHT, // Add padding to push content below the fixed header
//           }}
//         >
//           <Row
//             className="w-100 g-0 justify-content-center align-items-stretch"
//             style={{
//               minHeight: `calc(100vh - ${HEADER_HEIGHT})`, // Ensure row fills remaining viewport height
//             }}
//           >
//             {!isMobile && (
//               <Col
//                 lg={6}
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center", // Center image horizontally within its column if not taking full width
//                   justifyContent: "center", // Center image vertically
//                   padding: "0", // No padding at the Col level, controlled by inner div
//                   overflow: "hidden", // Prevent image from causing scroll
//                 }}
//               >
//                 <motion.div
//                   key={isLoginView ? "loginImagePanel" : "registerImagePanel"}
//                   initial={{ opacity: 0, x: -30 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.7, delay: 0.2 }}
//                   style={{
//                     maxWidth: "900px",
//                     width: "100vw", // Full screen width
//                     textAlign: "left",
//                     flexGrow: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-start",
//                     justifyContent: "center",
//                     paddingLeft: 0, // Remove left padding
//                     paddingRight: 0, // Optional: remove right padding too
//                     margin: 0,
//                   }}
//                 >
//                   <AnimatePresence mode="wait">
//                     <motion.div
//                       key={
//                         isLoginView
//                           ? "loginImageContent"
//                           : "registerImageContent"
//                       }
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       exit={{ opacity: 0 }}
//                       transition={{ duration: 0.4 }}
//                     >
//                       <img
//                         src={isLoginView ? LoginImage : RegisterImage}
//                         alt={
//                           isLoginView
//                             ? "Login Illustration"
//                             : "Registration Illustration"
//                         }
//                         style={{
//                           width: "100%",
//                           height: "auto",
//                           maxHeight: "520px",
//                           objectFit: "contain",
//                           display: "block", // Ensures no extra space below image
//                         }}
//                       />
//                     </motion.div>
//                   </AnimatePresence>
//                 </motion.div>
//               </Col>
//             )}

//             <Col
//               xs={12}
//               lg={isMobile ? 12 : 6}
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 // Removed justifyContent: "center" here to allow the form card to flex-grow and scroll
//                 // justifyContent: "center",
//                 padding: isMobile ? "20px" : "20px 20px 20px 15px", // Added 20px top/bottom padding for desktop
//                 background: "rgba(255, 255, 255, 0.0)",
//               }}
//             >
//               {/* Text above the form box */}
//               <motion.p
//                 key={isLoginView ? "loginTagline" : "signupTagline"}
//                 initial={{ opacity: 0, y: -20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: 0.1 }}
//                 style={{
//                   color: "black",
//                   fontSize: isMobile ? "1rem" : "1.2rem",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   display: "inline-block",
//                   maxWidth: "100%",
//                   fontWeight: "400",
//                   textAlign: "center",
//                   marginBottom: "15px",
//                   // maxWidth: "500px",
//                   // lineHeight: "1.4",
//                   // padding: "0 15px", // Added internal padding to tagline on smaller screens
//                 }}
//               >
//                 <AnimatePresence mode="wait">
//                   <motion.span
//                     key={
//                       isLoginView ? "loginTaglineText" : "registerTaglineText"
//                     }
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     exit={{ opacity: 0 }}
//                     transition={{ duration: 0.4 }}
//                   >
//                     {isLoginView
//                       ? "Empowering You to Learn, Experience, and Succeed"
//                       : "Explore Possibilities. Gain Experience. Shape Your Future."}
//                   </motion.span>
//                 </AnimatePresence>
//               </motion.p>

//               {/* Form card container - THIS IS WHERE THE SCROLL WILL BE APPLIED */}
//               <motion.div
//                 key={isLoginView ? "loginCard" : "registerCard"}
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6 }}
//                 style={{
//                   backgroundColor: "white",
//                   borderRadius: "16px", // Slightly smaller radius for a tighter look
//                   padding: "15px", // Remove all internal padding
//                   boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)", // Slightly lighter shadow
//                   width: "100%",
//                   maxWidth: "580px",
//                   border: "1px solid rgba(0,0,0,0.05)",
//                   flexGrow: 1,
//                   flexShrink: 1,
//                   maxHeight:"80vh",
//                   overflowY: "auto",
//                   minHeight: 50,
//                 }}
//               >
//                 <div style={{ textAlign: "center", padding: "12px 16px 0" }}>
//                   <motion.h2
//                     key={isLoginView ? "loginTitle" : "registerTitle"}
//                     initial={{ opacity: 0, y: -10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.1, duration: 0.4 }}
//                     style={{
//                       color: VETRINA_PURPLE,
//                       fontSize: isMobile ? "1.4rem" : "1.6rem",
//                       fontWeight: "bold",
//                       marginBottom: "5px",
//                     }}
//                   >
//                     {isLoginView ? "Welcome Back!" : "Create Account"}
//                   </motion.h2>
//                   <motion.p
//                     key={isLoginView ? "loginSubTitle" : "registerSubTitle"}
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.2, duration: 0.4 }}
//                     style={{
//                       color: VETRINA_TEXT_SECONDARY,
//                       fontSize: "0.85rem",
//                       marginTop: "5px",
//                     }}
//                   >
//                     {isLoginView
//                       ? "Sign in to continue your learning journey."
//                       : "Join our veterinary community!"}
//                   </motion.p>
//                 </div>
//                 <AnimatePresence mode="wait">
//                   {isLoginView ? (
//                     <motion.div
//                       key="loginFormDiv"
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       exit={{ opacity: 0 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <LoginForm
//                         toggleView={toggleView}
//                         onGoogleSuccess={handleGoogleAuthSuccess}
//                         apiBaseUrl={API_BASE_URL}
//                         themeColors={{
//                           VETRINA_PURPLE,
//                           VETRINA_ORANGE,
//                           VETRINA_DARK_PURPLE_ACCENT,
//                           VETRINA_TEXT_SECONDARY,
//                           VETRINA_BACKGROUND_LIGHT,
//                           VETRINA_TEXT_PRIMARY, // Added for Swal html
//                         }}
//                         commonStyles={{
//                           formControlStyle,
//                           inputGroupTextStyle,
//                           inputGroupControlStyle,
//                           submitButtonStyle,
//                           submitButtonDisabledStyle,
//                         }}
//                       />
//                     </motion.div>
//                   ) : (
//                     <motion.div
//                       key="registerFormDiv"
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       exit={{ opacity: 0 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <RegisterForm
//                         toggleView={toggleView}
//                         onGoogleSuccess={handleGoogleAuthSuccess}
//                         apiBaseUrl={API_BASE_URL}
//                         themeColors={{
//                           VETRINA_PURPLE,
//                           VETRINA_ORANGE,
//                           VETRINA_TEXT_SECONDARY,
//                           VETRINA_BACKGROUND_LIGHT,
//                           VETRINA_ACCENT_LIGHT_PURPLE,
//                         }}
//                         commonStyles={{
//                           formControlStyle,
//                           inputGroupTextStyle,
//                           inputGroupControlStyle,
//                           phoneInputStyle,
//                           submitButtonStyle,
//                           submitButtonDisabledStyle,
//                         }}
//                       />
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//                 <p
//                   style={{
//                     textAlign: "center",
//                     marginTop: "15px",
//                     fontSize: "0.75rem",
//                     color: VETRINA_TEXT_SECONDARY,
//                   }}
//                 >
//                   By {isLoginView ? "signing in" : "creating an account"}, you
//                   agree to our{" "}
//                   <a
//                     href="/terms"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ color: VETRINA_PURPLE, textDecoration: "none" }}
//                   >
//                     Terms
//                   </a>{" "}
//                   &{" "}
//                   <a
//                     href="/privacy"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ color: VETRINA_PURPLE, textDecoration: "none" }}
//                   >
//                     Privacy
//                   </a>
//                   .
//                 </p>
//               </motion.div>
//             </Col>
//           </Row>
//         </Container>

//         {/* Enhanced Background Animation */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             overflow: "hidden",
//             pointerEvents: "none",
//             zIndex: 0,
//           }}
//         >
//           {[...Array(8)].map((_, i) => (
//             <motion.div
//               key={i}
//               initial={{
//                 x: Math.random() * window.innerWidth,
//                 y: Math.random() * window.innerHeight,
//                 scale: 0.3 + Math.random() * 0.4,
//                 opacity: 0.05 + Math.random() * 0.1,
//               }}
//               animate={{
//                 x: Math.random() * window.innerWidth,
//                 y: Math.random() * window.innerHeight,
//                 rotate: 360,
//               }}
//               transition={{
//                 duration: 15 + Math.random() * 20,
//                 repeat: Number.POSITIVE_INFINITY,
//                 repeatType: "mirror",
//                 ease: "easeInOut",
//               }}
//               style={{
//                 position: "absolute",
//                 width: 100 + Math.random() * 150,
//                 height: 100 + Math.random() * 150,
//                 borderRadius: "50%",
//                 background:
//                   i % 3 === 0
//                     ? `radial-gradient(circle, ${VETRINA_PURPLE}20 0%, transparent 70%)`
//                     : i % 3 === 1
//                     ? `radial-gradient(circle, ${VETRINA_ORANGE}15 0%, transparent 70%)`
//                     : `radial-gradient(circle, #4A90E2 10 0%, transparent 70%)`,
//                 filter: "blur(20px)",
//               }}
//             />
//           ))}
//         </div>

//         {/* Custom PhoneInput and General Styles */}
//         <style>{`
//           /* Universal reset for html/body/root to ensure 100vh works without default margins */
//           html, body, #root {
//             margin: 0;
//             padding: 0;
//             height: 100%;
//             overflow: hidden; /* This is the ultimate guard against PAGE scrolling */
//           }

//           .PhoneInput {
//             display: flex;
//             width: 100%;
//           }
//           .PhoneInputCountry {
//             background-color: ${VETRINA_ACCENT_LIGHT_PURPLE};
//             border: 1px solid ${VETRINA_PURPLE};
//             border-right: none;
//             color: ${VETRINA_PURPLE};
//             border-top-left-radius: 8px;
//             border-bottom-left-radius: 8px;
//             padding: 0 12px;
//             display: flex;
//             align-items: center;
//             min-width: 45px;
//             height: 40px;
//           }
//           .PhoneInputCountrySelect {
//             background: transparent;
//             border: none;
//             height: 100%;
//             width: 100%;
//             font-size: 0.9rem;
//             color: transparent;
//             -webkit-appearance: none;
//             -moz-appearance: none;
//             appearance: none;
//             cursor: pointer;
//           }
//           .PhoneInputCountrySelect option {
//             color: ${VETRINA_TEXT_PRIMARY};
//           }
//           .PhoneInputCountrySelect:focus {
//             outline: none;
//             box-shadow: none;
//           }
//           .PhoneInputCountrySelectArrow {
//             color: ${VETRINA_PURPLE};
//             position: absolute;
//             right: 8px;
//             pointer-events: none;
//             top: 50%;
//             transform: translateY(-50%);
//           }
//           .PhoneInputInput {
//             border: 1px solid #ced4da;
//             padding: 8px 12px;
//             height: 40px;
//             border-top-right-radius: 8px;
//             border-bottom-right-radius: 8px;
//             border-top-left-radius: 0;
//             border-bottom-left-radius: 0;
//             border-left: none;
//             font-size: 0.9rem;
//             flex-grow: 1;
//           }
//           .PhoneInputInput:focus {
//             border-color: ${VETRINA_PURPLE} !important;
//             box-shadow: 0 0 0 0.25rem ${VETRINA_ACCENT_LIGHT_PURPLE} !important;
//           }

//           /* General Bootstrap input overrides */
//           .form-control:focus {
//             border-color: ${VETRINA_PURPLE} !important;
//             box-shadow: 0 0 0 0.25rem ${VETRINA_ACCENT_LIGHT_PURPLE} !important;
//           }
//           .input-group-text {
//             height: 40px;
//             font-size: 0.9rem;
//           }

//           /* Adjust Google button size for consistency */
//           .g_id_signin div {
//              width: 100% !important;
//              justify-content: center !important;
//              min-height: 40px !important;
//              border-radius: 20px !important;
//           }
//           .g_id_signin div > div:first-child {
//              padding: 0 12px !important;
//           }
//           .g_id_signin div > div:last-child {
//              flex-grow: 1;
//              text-align: center !important;
//              padding: 0 10px !important;
//           }

//           /* SweetAlert2 custom styling for consistency across all modals */
//           .swal2-popup {
//             border-radius: 15px !important;
//             font-family: 'Poppins', sans-serif !important;
//           }
//           .swal2-title {
//             color: ${VETRINA_PURPLE} !important;
//             font-size: 1.5em !important;
//           }
//           .swal2-html-container {
//             color: ${VETRINA_TEXT_SECONDARY} !important;
//             font-size: 1em !important;
//           }
//           .swal2-confirm {
//             background-color: ${VETRINA_PURPLE} !important;
//             border-color: ${VETRINA_PURPLE} !important;
//           }
//           .swal2-error .swal2-confirm {
//             background-color: ${VETRINA_ORANGE} !important;
//             border-color: ${VETRINA_ORANGE} !important;
//           }
//         `}</style>
//       </div>{" "}
//       {/* Closes the main page container div */}
//     </GoogleOAuthProvider>
//   ); // Closes the return statement
// }; // Closes the AuthPage functional component

// export default AuthPage; // Exports the component

// ************************************With Google Login*************************************************

// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import PhoneInput from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import {
//   FaUser,
//   FaEnvelope,
//   FaLock,
//   FaEye,
//   FaEyeSlash,
//   FaArrowLeft,
// } from "react-icons/fa";
// import axios from "axios";
// import VetLearnLogo from "../Images/Vetrina _Logo.png"; // Ensure this path is correct
// import RegisterImage from "../Images/TestLogin.png"; // Ensure this path is correct
// import LoginImage from "../Images/TestLogin.png"; // Ensure this path is correct
// import { motion, AnimatePresence } from "framer-motion";
// import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
// import Lottie from "react-lottie";

// // Vetrina Theme Colors
// const VETRINA_PURPLE = "#B8529E"; // Changed to a slightly darker purple for better contrast/visibility
// const VETRINA_ORANGE = "#FF6600";
// const VETRINA_TEXT_PRIMARY = "#333";
// const VETRINA_TEXT_SECONDARY = "#555";
// const VETRINA_BACKGROUND_LIGHT = "#f8f9fa";
// const VETRINA_ACCENT_LIGHT_PURPLE = "#ede7f6";
// const VETRINA_DARK_PURPLE_ACCENT = "#7D52A0";

// // API Configuration
// const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com/";
// const GOOGLE_CLIENT_ID =
//   "563227117215-cvm1hposi4qtk3kcrb3693vsq8osefts.apps.googleusercontent.com";

// // Lottie Animation for Initial Load (ensure this JSON is valid, or replace with empty object for fallback)
// const loadingAnimationData = {
//   v: "5.5.7",
//   fr: 30,
//   ip: 0,
//   op: 60,
//   w: 100,
//   h: 100,
//   nm: "Loading",
//   ddd: 0,
//   assets: [],
//   layers: [
//     {
//       ddd: 0,
//       ind: 1,
//       ty: 4,
//       nm: "Circle",
//       sr: 1,
//       ks: {
//         o: { a: 0, k: 100 },
//         r: {
//           a: 1,
//           k: [
//             { t: 0, s: [0], e: [360] },
//             { t: 60, s: [360], e: [720] },
//           ],
//         },
//         p: { a: 0, k: [50, 50, 0] },
//         a: { a: 0, k: [0, 0, 0] },
//         s: { a: 0, k: [100, 100, 100] },
//       },
//       ao: 0,
//       shapes: [
//         {
//           ty: "gr",
//           it: [
//             {
//               d: 1,
//               ty: "el",
//               s: { a: 0, k: [40, 40] },
//               p: { a: 0, k: [0, 0] },
//               nm: "Ellipse Path 1",
//             },
//             {
//               ty: "st",
//               c: { a: 0, k: [0.72, 0.32, 0.62, 1] },
//               o: { a: 0, k: 100 },
//               w: { a: 0, k: 6 },
//               lc: 2,
//               lj: 1,
//               ml: 4,
//               bm: 0,
//               nm: "Stroke 1",
//             },
//             {
//               ty: "tr",
//               p: { a: 0, k: [0, 0] },
//               a: { a: 0, k: [0, 0] },
//               s: { a: 0, k: [100, 100] },
//               r: { a: 0, k: 0 },
//               o: { a: 0, k: 100 },
//               nm: "Transform",
//             },
//           ],
//           nm: "Ellipse 1",
//         },
//       ],
//       ip: 0,
//       op: 60,
//       st: 0,
//       bm: 0,
//     },
//   ],
// };
// const defaultLottieOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: loadingAnimationData,
//   rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
// };

// // Header Height Constant
// const HEADER_HEIGHT = "60px";

// // Common Styles - Adjusted for better UI, prioritizing readability & touch targets
// const formControlBaseStyle = {
//   // Base for all Form.Control, can be overridden for specific parts
//   border: `1px solid ${VETRINA_PURPLE}`, // Default to purple border
//   borderRadius: "8px", // Consistent rounded corners
//   padding: "8px 12px",
//   height: "50px", // Consistent height for inputs
//   fontSize: "0.9rem",
// };

// const inputGroupTextStyle = {
//   backgroundColor: VETRINA_ACCENT_LIGHT_PURPLE,
//   border: `1px solid ${VETRINA_PURPLE}`,
//   borderRight: "none", // To merge with the input field
//   borderTopLeftRadius: "8px", // Rounded on the left
//   borderBottomLeftRadius: "8px", // Rounded on the left
//   borderTopRightRadius: "0", // Flat on the right to merge
//   borderBottomRightRadius: "0", // Flat on the right to merge
//   color: VETRINA_PURPLE,
//   padding: "0 12px",
//   display: "flex",
//   alignItems: "center",
//   minWidth: "45px",
//   height: "50px", // Ensure consistent height with form controls
// };

// const inputGroupControlWithinGroupStyle = {
//   // Applies to a Form.Control that is *inside* an InputGroup
//   ...formControlBaseStyle, // Inherit base properties
//   borderLeft: "none", // To merge with the InputGroup.Text
//   borderTopLeftRadius: "0", // Flat on the left to merge
//   borderBottomLeftRadius: "0", // Flat on the left to merge
// };

// const submitButtonStyle = {
//   background: `linear-gradient(45deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE})`,
//   borderColor: "transparent",
//   fontSize: "1rem",
//   padding: "10px",
//   marginTop: "10px",
//   marginBottom: "15px",
//   height: "42px",
//   borderRadius: "10px",
//   fontWeight: "bold",
//   boxShadow: `0 4px 15px rgba(184, 82, 158, 0.3)`,
//   width: "100%",
//   transition: "all 0.3s ease",
// };
// const submitButtonDisabledStyle = {
//   ...submitButtonStyle,
//   background: VETRINA_DARK_PURPLE_ACCENT,
//   cursor: "default",
// };

// const LoginForm = ({
//   toggleView,
//   onGoogleSuccess,
//   apiBaseUrl,
//   themeColors,
//   commonStyles,
// }) => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isErr, setIsErr] = useState(false); // Indicates a login error, used for border color
//   const [rememberMe, setRememberMe] = useState(false);

//   useEffect(() => {
//     const savedEmail = localStorage.getItem("savedEmail");
//     if (savedEmail) {
//       setEmail(savedEmail);
//       setRememberMe(true);
//     }
//   }, []);

//   const loginUser = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setIsErr(false); // Reset error state on new attempt
//     try {
//       const response = await axios.post(`${apiBaseUrl}auth/login/`, {
//         email,
//         password,
//       });
//       if (response.data && response.status === 200) {
//         if (rememberMe) localStorage.setItem("savedEmail", email);
//         else localStorage.removeItem("savedEmail");
//         localStorage.setItem("jwttoken", response.data.access);
//         const role = response.data.role;
//         if (role) localStorage.setItem("role", role);
//         const roleMapper = {
//           Client: "/result",
//           Trainer: "/result",
//           Instructor: "/Home",
//           Admin: "/lmsadmindashboard",
//         };
//         const targetPath = roleMapper[role] || "/Home"; // Default to /Home if role not explicitly mapped
//         let swalTitle = "Success!";
//         let swalHtml = `<p style="color: ${themeColors.VETRINA_TEXT_PRIMARY};">You have logged in successfully.</p>`;
//         if (role === "Student") {
//           swalTitle = "Welcome Back!";
//           swalHtml = `<div style="text-align: center; padding: 10px;"><h2 style="color: ${themeColors.VETRINA_PURPLE}; margin-bottom: 15px; font-size: 1.5em;">Ready to Learn?</h2><p style="font-size: 1.1em; color: ${themeColors.VETRINA_TEXT_SECONDARY}; line-height: 1.6;">Your journey to knowledge continues here!</p></div>`;
//         }
//         Swal.fire({
//           title: swalTitle,
//           html: swalHtml,
//           icon: "success",
//           background: VETRINA_BACKGROUND_LIGHT,
//           confirmButtonColor: themeColors.VETRINA_PURPLE,
//           timer: swalHtml.includes("Ready to Learn?") ? 3500 : 1500,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         }).then(() => navigate(targetPath));
//       }
//     } catch (error) {
//       const errMessage =
//         error.response?.data?.error ||
//         error.response?.data?.detail ||
//         "Invalid Credentials or server error.";
//       Swal.fire({
//         title: "Login Failed!",
//         text: errMessage,
//         icon: "error",
//         background: VETRINA_BACKGROUND_LIGHT,
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//         confirmButtonText: "Try Again",
//       });
//       setIsErr(true); // Set error state to trigger red border
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Form onSubmit={loginUser}>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           <InputGroup.Text
//             style={{
//               ...commonStyles.inputGroupTextStyle,
//               borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE, // Red if error, Purple otherwise
//             }}
//           >
//             <FaEnvelope />
//           </InputGroup.Text>
//           <Form.Control
//             type="email"
//             placeholder="Email Address"
//             value={email}
//             onChange={(e) => {
//               setIsErr(false); // Clear error on input change
//               setEmail(e.target.value);
//             }}
//             required
//             style={{
//               ...commonStyles.inputGroupControlWithinGroupStyle,
//               borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE, // Red if error, Purple otherwise
//               // This input is the last one in its InputGroup, so it needs rounded right corners
//               borderTopRightRadius: "8px",
//               borderBottomRightRadius: "8px",
//             }}
//           />
//         </InputGroup>
//       </Form.Group>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           <InputGroup.Text
//             style={{
//               ...commonStyles.inputGroupTextStyle,
//               borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE, // Red if error, Purple otherwise
//             }}
//           >
//             <FaLock />
//           </InputGroup.Text>
//           <Form.Control
//             type={showPassword ? "text" : "password"}
//             placeholder="Password"
//             value={password}
//             onChange={(e) => {
//               setIsErr(false); // Clear error on input change
//               setPassword(e.target.value);
//             }}
//             required
//             style={{
//               ...commonStyles.inputGroupControlWithinGroupStyle,
//               borderRight: "none", // This input is followed by a button, so no right border
//               borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE, // Red if error, Purple otherwise
//               borderTopRightRadius: "0", // Flat on the right to merge with button
//               borderBottomRightRadius: "0",
//             }}
//           />
//           <Button
//             onClick={() => setShowPassword(!showPassword)}
//             variant="outline-secondary"
//             style={{
//               height: commonStyles.inputGroupControlWithinGroupStyle.height,
//               borderColor: themeColors.VETRINA_PURPLE, // Purple border for the button
//               borderLeft: "none",
//               borderTopRightRadius: "8px", // Rounded button corners
//               borderBottomRightRadius: "8px",
//               color: themeColors.VETRINA_PURPLE,
//               padding: "0 12px",
//             }}
//           >
//             {showPassword ? <FaEyeSlash /> : <FaEye />}
//           </Button>
//         </InputGroup>
//       </Form.Group>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "15px",
//           marginTop: "5px",
//         }}
//       >
//         <Form.Check
//           type="checkbox"
//           id="rememberMe"
//           label="Remember me"
//           checked={rememberMe}
//           onChange={(e) => setRememberMe(e.target.checked)}
//           style={{
//             fontSize: "0.8rem",
//             color: themeColors.VETRINA_TEXT_SECONDARY,
//           }}
//         />
//         <a
//           href="#!"
//           onClick={(e) => {
//             e.preventDefault();
//             navigate("/reset-password");
//           }}
//           style={{
//             color: themeColors.VETRINA_PURPLE,
//             textDecoration: "none",
//             fontSize: "0.8rem",
//             fontWeight: "500",
//           }}
//           onMouseOver={(e) =>
//             (e.target.style.color = themeColors.VETRINA_ORANGE)
//           }
//           onMouseOut={(e) =>
//             (e.target.style.color = themeColors.VETRINA_PURPLE)
//           }
//         >
//           Forgot Password?
//         </a>
//       </div>
//       <Button
//         type="submit"
//         disabled={loading}
//         style={
//           loading
//             ? commonStyles.submitButtonDisabledStyle
//             : commonStyles.submitButtonStyle
//         }
//       >
//         {loading ? (
//           <>
//             <span
//               className="spinner-border spinner-border-sm"
//               style={{ marginRight: "8px" }}
//             ></span>
//             Signing In...
//           </>
//         ) : (
//           "Sign In"
//         )}
//       </Button>
//       <div
//         style={{ textAlign: "center", margin: "15px 0", position: "relative" }}
//       >
//         <hr style={{ backgroundColor: "#e0e0e0" }} />
//         <span
//           style={{
//             position: "absolute",
//             top: "-10px",
//             backgroundColor: "white",
//             padding: "0 8px",
//             color: themeColors.VETRINA_TEXT_SECONDARY,
//             left: "50%",
//             transform: "translateX(-50%)",
//             fontSize: "0.8rem",
//           }}
//         >
//           OR
//         </span>
//       </div>
//       <motion.div
//         initial={{ y: 20, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ delay: 0.2, duration: 0.5 }}
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           marginBottom: "15px",
//         }}
//       >
//         <GoogleLogin
//           onSuccess={onGoogleSuccess}
//           onError={(error) =>
//             Swal.fire({
//               title: "Error!",
//               text: error.message || "Google sign-in failed",
//               icon: "error",
//               confirmButtonColor: themeColors.VETRINA_ORANGE,
//             })
//           }
//           theme="outline"
//           size="medium"
//           text="signin_with"
//           shape="pill"
//           logo_alignment="center"
//         />
//       </motion.div>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: "15px",
//           fontSize: "0.85rem",
//           color: themeColors.VETRINA_TEXT_PRIMARY,
//         }}
//       >
//         New to VetLearn?{" "}
//         <a
//           href="#!"
//           onClick={(e) => {
//             e.preventDefault();
//             toggleView();
//           }}
//           style={{
//             color: themeColors.VETRINA_PURPLE,
//             textDecoration: "none",
//             fontWeight: "bold",
//           }}
//           onMouseOver={(e) =>
//             (e.target.style.color = themeColors.VETRINA_ORANGE)
//           }
//           onMouseOut={(e) =>
//             (e.target.style.color = themeColors.VETRINA_PURPLE)
//           }
//         >
//           Create Account
//         </a>
//       </p>
//     </Form>
//   );
// };

// const RegisterForm = ({
//   toggleView,
//   onGoogleSuccess,
//   apiBaseUrl,
//   themeColors,
//   commonStyles,
// }) => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     confirmPassword: "",
//     otp: "",
//   });
//   const [emailError, setEmailError] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [showOTPField, setShowOTPField] = useState(false);
//   const [isEmailVerifiedStepDone, setIsEmailVerifiedStepDone] = useState(false);
//   const [loading, setLoading] = useState(false); // For main form submission (and final dialog submission)
//   const [otpLoading, setOtpLoading] = useState(false); // For OTP send button
//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const [termsError, setTermsError] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((p) => ({ ...p, [name]: value }));
//     if (name === "email") validateEmail(value);
//     if (name === "confirmPassword") validatePasswords(formData.password, value);
//     if (name === "password") validatePasswords(value, formData.confirmPassword);
//   };
//   const validateEmail = (email) => {
//     /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email)
//       ? setEmailError("")
//       : setEmailError("Invalid email format.");
//   };
//   const validatePasswords = (pw, cpw) => {
//     cpw && pw !== cpw
//       ? setPasswordError("Passwords do not match.")
//       : setPasswordError("");
//   };
//   const handlePhoneChange = (value) =>
//     setFormData((p) => ({ ...p, phoneNumber: value }));

//   const sendOTP = () => {
//     if (!formData.email || emailError) {
//       Swal.fire({
//         title: "Error",
//         text: "Valid email required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return;
//     }
//     setOtpLoading(true);
//     axios
//       .post(`${apiBaseUrl}auth/verify-email/`, { email: formData.email })
//       .then(() => {
//         Swal.fire({
//           title: "OTP Sent",
//           text: "Check email for OTP.",
//           icon: "success",
//           confirmButtonColor: themeColors.VETRINA_PURPLE,
//         });
//         setShowOTPField(true);
//         setIsEmailVerifiedStepDone(true);
//       })
//       .catch(() =>
//         Swal.fire({
//           title: "Error",
//           text: "Failed to send OTP.",
//           icon: "error",
//           confirmButtonColor: themeColors.VETRINA_ORANGE,
//         })
//       )
//       .finally(() => setOtpLoading(false));
//   };

//   // --- Initial Form Validation (before dialog) ---
//   const validateInitialForm = useCallback(() => {
//     const {
//       firstName,
//       lastName,
//       phoneNumber,
//       email,
//       password,
//       confirmPassword,
//     } = formData;

//     if (!firstName || !lastName) {
//       Swal.fire({
//         text: "First Name and Last Name are required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (!phoneNumber) {
//       Swal.fire({
//         text: "Phone number is required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (emailError || !email) {
//       Swal.fire({
//         text: "A valid email address is required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (password.length < 6) {
//       Swal.fire({
//         text: "Password must be at least 6 characters long.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (password !== confirmPassword) {
//       Swal.fire({
//         text: "Passwords do not match.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     if (!isEmailVerifiedStepDone) {
//       Swal.fire({
//         text: "Please verify your email address first by sending and entering the OTP.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     // The main form checkbox is checked before the dialog opens (due to 'required' and initial validation)
//     if (!termsAccepted) {
//       setTermsError(true); // Ensure visual feedback on the main form
//       Swal.fire({
//         text: "You must accept the Terms & Privacy to proceed.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//       return false;
//     }
//     return true;
//   }, [
//     formData,
//     emailError,
//     isEmailVerifiedStepDone,
//     termsAccepted, // Dependency for termsAccepted check
//     themeColors.VETRINA_ORANGE,
//   ]);

//   // --- Handles submission from the main form (opens dialog) ---
//   const handleInitialRegisterSubmit = (e) => {
//     e.preventDefault();
//     setTermsError(false); // Clear previous terms error on main form
//     if (!validateInitialForm()) {
//       return;
//     }

//     // Format password for display purposes (e.g., mask it)
//     const maskedPassword = "*".repeat(formData.password.length);

//     // Reset termsAccepted state for the dialog's checkbox to ensure it's unchecked
//     setTermsAccepted(false);

//     Swal.fire({
//       title: "Confirm Your Details",
//       html: `
//             <div style="text-align: left; font-size: 0.95em; color: ${
//               themeColors.VETRINA_TEXT_PRIMARY
//             };">
//                 <p><strong>First Name:</strong> ${formData.firstName}</p>
//                 <p><strong>Last Name:</strong> ${formData.lastName}</p>
//                 <p><strong>Email:</strong> ${formData.email}</p>
//                 <p><strong>Phone:</strong> ${formData.phoneNumber}</p>
//                 <p><strong>Password:</strong> ${maskedPassword}</p>
//                 ${
//                   showOTPField
//                     ? `<p><strong>OTP:</strong> <input type="text" id="swal-input-otp" class="swal2-input" placeholder="Enter OTP" value="${formData.otp}" style="border-color: ${themeColors.VETRINA_PURPLE};"></p>`
//                     : ""
//                 }
//                 <div class="form-check" style="margin-top: 15px; margin-bottom: 5px;">
//                     <input class="form-check-input" type="checkbox" id="swal-checkbox-terms" style="accent-color: ${themeColors.VETRINA_PURPLE};">
//                     <label class="form-check-label" for="swal-checkbox-terms" style="font-size: 0.85em; color: ${
//                       themeColors.VETRINA_TEXT_SECONDARY
//                     };">
//                         I confirm that all information provided is true and complete. I understand that any false or misleading details may lead to rejection or termination. I also authorize background verification and accept that the company may take appropriate action, including legal steps, as per its policy.
//                     </label>
//                     <div id="swal-terms-error" style="color: #e74c3c; font-size: 0.75em; margin-top: 5px; display: ${
//                       termsError ? "block" : "none"
//                     };"></div>
//                 </div>
//                 ${
//                   showOTPField && !formData.otp
//                     ? `<div id="swal-otp-error" style="color: #e74c3c; font-size: 0.75em; margin-top: 5px;">OTP is required.</div>`
//                     : ""
//                 }
//             </div>
//         `,
//       icon: "info",
//       showCancelButton: true,
//       confirmButtonText: "Confirm & Create",
//       cancelButtonText: "Edit Details",
//       confirmButtonColor: themeColors.VETRINA_PURPLE,
//       cancelButtonColor: themeColors.VETRINA_ORANGE,
//       background: VETRINA_BACKGROUND_LIGHT,
//       preConfirm: () => {
//         const otpInput = Swal.getPopup().querySelector("#swal-input-otp");
//         const termsCheckbox = Swal.getPopup().querySelector(
//           "#swal-checkbox-terms"
//         );
//         const otpErrorDiv = Swal.getPopup().querySelector("#swal-otp-error");
//         const termsErrorDiv =
//           Swal.getPopup().querySelector("#swal-terms-error");

//         let dialogValid = true;

//         // Clear previous dialog errors
//         if (otpErrorDiv) otpErrorDiv.style.display = "none";
//         if (termsErrorDiv) termsErrorDiv.style.display = "none";
//         // Do NOT reset termsError here, as it refers to the main form's error state.
//         // It's better to let `setTermsError` update based on the dialog's outcome.

//         // Validate OTP if field is shown
//         if (showOTPField && (!otpInput || !otpInput.value)) {
//           if (otpErrorDiv) otpErrorDiv.style.display = "block";
//           Swal.showValidationMessage("OTP is required.");
//           dialogValid = false;
//         } else {
//           setFormData((p) => ({ ...p, otp: otpInput ? otpInput.value : "" })); // Update OTP in state
//         }

//         // Validate Terms & Privacy checkbox (in dialog)
//         if (!termsCheckbox.checked) {
//           if (termsErrorDiv) termsErrorDiv.style.display = "block";
//           // Only set this state if validation fails in dialog, for consistency
//           // This termsError affects the *main form* checkbox, which might be confusing
//           // Consider a separate state for dialog-specific terms error if you want to avoid this.
//           setTermsError(true);
//           Swal.showValidationMessage("You must confirm the details to proceed.");
//           dialogValid = false;
//         } else {
//           setTermsAccepted(true); // Update terms accepted in state for future reference
//           setTermsError(false); // Clear error on main form as well if successfully checked in dialog
//         }

//         if (!dialogValid) {
//           return false; // Prevent preConfirm from resolving if validation fails
//         }

//         return { confirmed: true }; // Resolve preConfirm to proceed
//       },
//       didOpen: () => {
//         const otpInput = Swal.getPopup().querySelector("#swal-input-otp");
//         if (otpInput) {
//           otpInput.addEventListener("input", (e) => {
//             setFormData((p) => ({ ...p, otp: e.target.value }));
//             // Clear OTP error message on input
//             const otpErrorDiv =
//               Swal.getPopup().querySelector("#swal-otp-error");
//             if (otpErrorDiv) otpErrorDiv.style.display = "none";
//           });
//         }
//         const termsCheckbox = Swal.getPopup().querySelector(
//           "#swal-checkbox-terms"
//         );
//         if (termsCheckbox) {
//           termsCheckbox.addEventListener("change", (e) => {
//             // This updates the component state for the main form's checkbox
//             // and the dialog's checkbox behavior.
//             setTermsAccepted(e.target.checked);
//             // Clear terms error message on change for the dialog
//             const termsErrorDiv =
//               Swal.getPopup().querySelector("#swal-terms-error");
//             if (termsErrorDiv) termsErrorDiv.style.display = "none";
//           });
//         }
//       },
//       willClose: () => {
//         // If the dialog is closed without confirmation,
//         // it might be good to reset the main form's checkbox state as well,
//         // so the user has to re-check it on the main form to trigger the dialog again.
//         // Or keep it checked if you assume the main form's check is persistent.
//         // For now, let's keep it as is, as the main form already required it to be checked.
//         // The dialog's own checkbox state is ephemeral.
//       },
//     }).then((result) => {
//       if (result.isConfirmed) {
//         // This means preConfirm passed validation
//         handleSubmitConfirmed(); // Call the final submission function
//       }
//     });
//   };

//   // --- Final Submission Function (called from dialog) ---
//   const handleSubmitConfirmed = async () => {
//     setLoading(true); // Show loading on the button again
//     Swal.fire({
//       title: "Creating account...",
//       html: `
//         <div class="spinner-border text-primary" role="status">
//           <span class="visually-hidden">Creating...</span>
//         </div>
//         <p class="mt-3">Please wait while your account is being created.</p>
//       `,
//       allowOutsideClick: false,
//       showConfirmButton: false,
//     });

//     try {
//       const response = await axios.post(`${apiBaseUrl}auth/signup/`, {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         mobile_number: formData.phoneNumber,
//         otp: Number.parseInt(formData.otp),
//       });

//       Swal.close();
//       Swal.fire({
//         title: "Success!",
//         text: "Account created! Please log in.",
//         icon: "success",
//         confirmButtonColor: themeColors.VETRINA_PURPLE,
//       });
//       toggleView(); // Switch to login view
//     } catch (err) {
//       Swal.close();
//       const msg =
//         err.response?.data?.detail ||
//         err.response?.data?.email?.[0] ||
//         err.response?.data?.mobile_number?.[0] ||
//         err.response?.data?.otp?.[0] || // Added OTP specific error from backend
//         "Registration failed.";
//       Swal.fire({
//         title: "Error",
//         text: msg,
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Form onSubmit={handleInitialRegisterSubmit}>
//       {" "}
//       {/* Form now submits to this new function */}
//       <Row>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaUser />
//               </InputGroup.Text>
//               <Form.Control
//                 type="text"
//                 name="firstName"
//                 placeholder="First Name"
//                 value={formData.firstName}
//                 onChange={handleChange}
//                 required
//                 style={commonStyles.inputGroupControlWithinGroupStyle} // Uses the new style
//               />
//             </InputGroup>
//           </Form.Group>
//         </Col>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaUser />
//               </InputGroup.Text>
//               <Form.Control
//                 type="text"
//                 name="lastName"
//                 placeholder="Last Name"
//                 value={formData.lastName}
//                 onChange={handleChange}
//                 required
//                 style={commonStyles.inputGroupControlWithinGroupStyle} // Uses the new style
//               />
//             </InputGroup>
//           </Form.Group>
//         </Col>
//       </Row>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//             <FaEnvelope />
//           </InputGroup.Text>
//           <Form.Control
//             type="email"
//             name="email"
//             placeholder="Email Address"
//             value={formData.email}
//             onChange={handleChange}
//             isInvalid={!!emailError}
//             required
//             style={{
//               ...commonStyles.inputGroupControlWithinGroupStyle,
//               borderRight: "none", // This input is followed by a button
//               borderTopRightRadius: "0", // Flat on the right to merge with button
//               borderBottomRightRadius: "0",
//               borderColor: emailError ? undefined : VETRINA_PURPLE, // Let Bootstrap handle invalid, default to purple
//             }}
//           />
//           <Button
//             onClick={sendOTP}
//             disabled={otpLoading || !formData.email || !!emailError}
//             style={{
//               backgroundColor: themeColors.VETRINA_PURPLE,
//               borderColor: themeColors.VETRINA_PURPLE, // Purple border for the button
//               height: commonStyles.inputGroupControlWithinGroupStyle.height,
//               borderTopRightRadius: "8px", // Rounded button corners
//               borderBottomRightRadius: "8px",
//               borderTopLeftRadius: "0",
//               borderBottomLeftRadius: "0",
//               fontSize: commonStyles.inputGroupControlWithinGroupStyle.fontSize,
//               padding: "0 12px",
//             }}
//           >
//             {otpLoading ? (
//               <>
//                 <span
//                   className="spinner-border spinner-border-sm"
//                   style={{ marginRight: "5px" }}
//                 ></span>
//                 Sending
//               </>
//             ) : (
//               "Verify"
//             )}
//           </Button>
//           {emailError && (
//             <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
//               {emailError}
//             </Form.Control.Feedback>
//           )}
//         </InputGroup>
//       </Form.Group>
//       <Form.Group className="mb-3">
//         <InputGroup>
//           {/* PhoneInput is self-contained. Its styling is handled by global CSS to ensure no gap and purple borders. */}
//           <PhoneInput
//             international
//             defaultCountry="IN"
//             value={formData.phoneNumber}
//             onChange={handlePhoneChange}
//             inputComponent={Form.Control} // This renders it as a Bootstrap Form.Control
//             inputProps={{
//               name: "phoneNumber",
//               required: true,
//               placeholder: "Phone Number",
//             }}
//           />
//         </InputGroup>
//       </Form.Group>
//       <Row>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaLock />
//               </InputGroup.Text>
//               <Form.Control
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 placeholder="Password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   ...commonStyles.inputGroupControlWithinGroupStyle,
//                   borderRight: "none", // Followed by button
//                   borderTopRightRadius: "0", // Flat on the right
//                   borderBottomRightRadius: "0",
//                 }}
//               />
//               <Button
//                 onClick={() => setShowPassword(!showPassword)}
//                 variant="outline-secondary"
//                 style={{
//                   height: commonStyles.inputGroupControlWithinGroupStyle.height,
//                   borderColor: themeColors.VETRINA_PURPLE, // Purple border for button
//                   borderLeft: "none",
//                   borderTopRightRadius: "8px", // Rounded button corners
//                   borderBottomRightRadius: "8px",
//                   color: themeColors.VETRINA_PURPLE,
//                   padding: "0 12px",
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </Button>
//             </InputGroup>
//           </Form.Group>
//         </Col>
//         <Col md={6}>
//           <Form.Group className="mb-3">
//             <InputGroup>
//               <InputGroup.Text style={commonStyles.inputGroupTextStyle}>
//                 <FaLock />
//               </InputGroup.Text>
//               <Form.Control
//                 type={showConfirmPassword ? "text" : "password"}
//                 name="confirmPassword"
//                 placeholder="Confirm Password"
//                 value={formData.confirmPassword}
//                 onChange={handleChange}
//                 isInvalid={!!passwordError}
//                 required
//                 style={{
//                   ...commonStyles.inputGroupControlWithinGroupStyle,
//                   borderRight: "none", // Followed by button
//                   borderTopRightRadius: "0", // Flat on the right
//                   borderBottomRightRadius: "0",
//                 }}
//               />
//               <Button
//                 onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                 variant="outline-secondary"
//                 style={{
//                   height: commonStyles.inputGroupControlWithinGroupStyle.height,
//                   borderColor: themeColors.VETRINA_PURPLE, // Purple border for button
//                   borderLeft: "none",
//                   borderTopRightRadius: "8px", // Rounded button corners
//                   borderBottomRightRadius: "8px",
//                   color: themeColors.VETRINA_PURPLE,
//                   padding: "0 12px",
//                 }}
//               >
//                 {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//               </Button>
//               {passwordError && (
//                 <Form.Control.Feedback
//                   type="invalid"
//                   style={{ display: "block" }}
//                 >
//                   {passwordError}
//                 </Form.Control.Feedback>
//               )}
//             </InputGroup>
//           </Form.Group>
//         </Col>
//       </Row>
//       {showOTPField && (
//         <motion.div
//           initial={{ opacity: 0, height: 0 }}
//           animate={{ opacity: 1, height: "auto" }}
//           transition={{ duration: 0.3 }}
//         >
//           <Form.Group className="mb-3">
//             {/* OTP is a standalone input, uses formControlBaseStyle */}
//             <Form.Control
//               type="text"
//               name="otp"
//               value={formData.otp}
//               onChange={handleChange}
//               required
//               style={commonStyles.formControlBaseStyle}
//               placeholder="Enter OTP"
//             />
//           </Form.Group>
//         </motion.div>
//       )}
//       {/* NEW CHECKBOX FOR TERMS & PRIVACY */}
//       <Form.Group className="mb-3">
//         <Form.Check
//           type="checkbox"
//           id="termsAndPrivacy"
//           label={
//             <span
//               style={{
//                 fontSize: "0.85rem",
//                 color: themeColors.VETRINA_TEXT_SECONDARY,
//               }}
//             >
//               I agree to the{" "}
//               <a
//                 href="/terms"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{
//                   color: themeColors.VETRINA_PURPLE,
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                 }}
//                 onMouseOver={(e) =>
//                   (e.target.style.color = themeColors.VETRINA_ORANGE)
//                 }
//                 onMouseOut={(e) =>
//                   (e.target.style.color = themeColors.VETRINA_PURPLE)
//                 }
//               >
//                 Terms
//               </a>{" "}
//               &{" "}
//               <a
//                 href="/privacy"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{
//                   color: themeColors.VETRINA_PURPLE,
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                 }}
//                 onMouseOver={(e) =>
//                   (e.target.style.color = themeColors.VETRINA_ORANGE)
//                 }
//                 onMouseOut={(e) =>
//                   (e.target.style.color = themeColors.VETRINA_PURPLE)
//                 }
//               >
//                 Privacy Policy
//               </a>
//             </span>
//           }
//           checked={termsAccepted}
//           onChange={(e) => {
//             setTermsAccepted(e.target.checked);
//             setTermsError(false); // Clear error when checkbox is interacted with
//           }}
//           isInvalid={termsError} // Apply Bootstrap invalid styling
//           required // Make it a required field (for form validation, dialog handles its own)
//         />
//         {termsError && (
//           <Form.Control.Feedback
//             type="invalid"
//             style={{ display: "block", fontSize: "0.75rem" }}
//           >
//             You must accept the Terms & Privacy.
//           </Form.Control.Feedback>
//         )}
//       </Form.Group>
//       <Button
//         type="submit"
//         disabled={loading} // Disable button if loading (during API call)
//         style={{
//           width: "150px", // or any desired small width
//           padding: "8px 12px", // adjust for smaller button feel
//           fontSize: "0.9rem",
//           ...(loading
//             ? commonStyles.submitButtonDisabledStyle
//             : commonStyles.submitButtonStyle),
//         }}
//       >
//         {loading ? (
//           <>
//             <span
//               className="spinner-border spinner-border-sm"
//               style={{ marginRight: "8px" }}
//             ></span>
//             Creating...
//           </>
//         ) : (
//           "Sign Up"
//         )}
//       </Button>
//       <div
//         style={{ textAlign: "center", margin: "15px 0", position: "relative" }}
//       >
//         <hr style={{ backgroundColor: "#e0e0e0" }} />
//         <span
//           style={{
//             position: "absolute",
//             top: "-10px",
//             backgroundColor: "white",
//             padding: "0 8px",
//             color: themeColors.VETRINA_TEXT_SECONDARY,
//             left: "50%",
//             transform: "translateX(-50%)",
//             fontSize: "0.8rem",
//           }}
//         >
//           OR
//         </span>
//       </div>
//       <motion.div
//         initial={{ y: 20, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ delay: 0.2, duration: 0.5 }}
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           marginBottom: "15px",
//         }}
//       >
//         <GoogleLogin
//           onSuccess={onGoogleSuccess}
//           onError={(error) =>
//             Swal.fire({
//               title: "Error!",
//               text: error.message || "Google sign-up failed",
//               icon: "error",
//               confirmButtonColor: VETRINA_ORANGE,
//             })
//           }
//           theme="outline"
//           size="medium"
//           text="signup_with"
//           shape="pill"
//           logo_alignment="center"
//         />
//       </motion.div>
//       <p
//         style={{
//           textAlign: "center",
//           marginTop: "15px",
//           fontSize: "0.85rem",
//           color: themeColors.VETRINA_TEXT_PRIMARY,
//         }}
//       >
//         Already have an account?{" "}
//         <a
//           href="#!"
//           onClick={(e) => {
//             e.preventDefault();
//             toggleView();
//           }}
//           style={{
//             color: themeColors.VETRINA_PURPLE,
//             textDecoration: "none",
//             fontWeight: "bold",
//           }}
//           onMouseOver={(e) =>
//             (e.target.style.color = themeColors.VETRINA_ORANGE)
//           }
//           onMouseOut={(e) =>
//             (e.target.style.color = themeColors.VETRINA_PURPLE)
//           }
//         >
//           Sign In
//         </a>
//       </p>
//     </Form>
//   );
// };

// // ForgotPasswordPage remains unchanged from the previous iteration, retaining its own distinct sizing for a larger, simpler form.
// export const ForgotPasswordPage = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);

//   const themeColors = {
//     VETRINA_PURPLE,
//     VETRINA_ORANGE,
//     VETRINA_TEXT_PRIMARY,
//     VETRINA_TEXT_SECONDARY,
//     VETRINA_BACKGROUND_LIGHT,
//     VETRINA_ACCENT_LIGHT_PURPLE,
//     VETRINA_DARK_PURPLE_ACCENT,
//   };
//   // This page retains its own slightly larger styles for clarity, separate from AuthPage
//   // Adjusted for consistency with the new common styles where appropriate
//   const localCommonStyles = {
//     formControlStyle: {
//       ...formControlBaseStyle, // Use base style
//       height: "40px", // Retain specific height for this page
//       borderRadius: "8px", // Ensure rounded corners
//     },
//     inputGroupTextStyle: {
//       ...inputGroupTextStyle, // Use base style
//       height: "40px", // Retain specific height for this page
//       minWidth: "45px",
//       padding: "0 12px",
//       borderRadius: "8px", // Ensure rounded corners
//     },
//     inputGroupControlStyle: {
//       ...inputGroupControlWithinGroupStyle, // Use base style for input in group
//       height: "40px", // Retain specific height for this page
//       padding: "8px 12px",
//       fontSize: "0.9rem",
//       borderRadius: "8px", // Ensure rounded corners
//     },
//     formLabelStyle: {
//       fontWeight: "500",
//       color: VETRINA_TEXT_SECONDARY,
//       marginBottom: "5px",
//       fontSize: "0.85rem",
//     },
//     submitButtonStyle: {
//       ...submitButtonStyle,
//       height: "42px",
//       padding: "10px",
//       fontSize: "1rem",
//       borderRadius: "20px",
//     },
//     submitButtonDisabledStyle: {
//       ...submitButtonDisabledStyle,
//       height: "42px",
//       padding: "10px",
//       fontSize: "1rem",
//       borderRadius: "20px",
//     },
//   };

//   const handleResetPasswordRequest = async (e) => {
//     e.preventDefault();
//     if (!email) {
//       Swal.fire({
//         text: "Email address is required.",
//         icon: "error",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//         background: VETRINA_BACKGROUND_LIGHT,
//         customClass: { popup: "swal-custom-popup" },
//       });
//       return;
//     }
//     setLoading(true);
//     try {
//       await axios.post(`${API_BASE_URL}auth/forgot-password/`, { email });
//       Swal.fire({
//         title: "Instructions Sent!",
//         html: `<p style="color: ${themeColors.VETRINA_TEXT_SECONDARY};">If an account with that email exists, password reset instructions have been sent. Please check your inbox (and spam folder).</p>`,
//         icon: "success",
//         confirmButtonColor: themeColors.VETRINA_PURPLE,
//         background: VETRINA_BACKGROUND_LIGHT,
//         customClass: { popup: "swal-custom-popup" },
//       }).then(() => {
//         setEmail("");
//       });
//     } catch (error) {
//       Swal.fire({
//         title: "Request Processed",
//         html: `<p style="color: ${themeColors.VETRINA_TEXT_SECONDARY};">If an account with that email exists, instructions have been sent. If you don't receive an email, please check your spam folder or try again later.</p>`,
//         icon: "info",
//         confirmButtonColor: themeColors.VETRINA_ORANGE,
//         background: VETRINA_BACKGROUND_LIGHT,
//         customClass: { popup: "swal-custom-popup" },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         background: `linear-gradient(135deg, ${themeColors.VETRINA_ACCENT_LIGHT_PURPLE}99 0%, #e9eaf7AA 100%)`,
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "30px 15px",
//         fontFamily: "'Poppins', sans-serif",

//       }}
//     >
//       <Container>
//         <Row className="justify-content-center">
//           <Col md={8} lg={6} xl={5}>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//               style={{
//                 backgroundColor: "rgba(255, 255, 255, 0.98)",
//                 borderRadius: "20px",
//                 padding: "30px 25px",
//                 boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
//                 border: "1px solid rgba(255,255,255,0.3)",
//               }}
//             >
//               <div style={{ textAlign: "center", marginBottom: "25px" }}>
//                 <img
//                   src={VetLearnLogo}
//                   alt="VetLearn Logo"
//                   onClick={() => navigate("/")}
//                   style={{
//                     height: "2em",
//                     marginBottom: "15px",
//                     cursor: "pointer",
//                   }}
//                 />
//                 <h2
//                   style={{
//                     color: themeColors.VETRINA_PURPLE,
//                     fontWeight: "bold",
//                     fontSize: "1.7rem",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   Forgot Password?
//                 </h2>
//                 <p
//                   style={{
//                     color: themeColors.VETRINA_TEXT_SECONDARY,
//                     fontSize: "0.9rem",
//                     lineHeight: "1.5",
//                   }}
//                 >
//                   Enter your email address below. If it's associated with an
//                   account, we'll send you instructions to reset your password.
//                 </p>
//               </div>
//               <Form onSubmit={handleResetPasswordRequest}>
//                 <Form.Group className="mb-4">
//                   <Form.Label style={localCommonStyles.formLabelStyle}>
//                     Email Address
//                   </Form.Label>
//                   <InputGroup>
//                     <InputGroup.Text
//                       style={localCommonStyles.inputGroupTextStyle}
//                     >
//                       <FaEnvelope />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type="email"
//                       placeholder="Enter your registered email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       required
//                       style={localCommonStyles.inputGroupControlStyle} // Uses new style
//                     />
//                   </InputGroup>
//                 </Form.Group>
//                 <Button
//                   type="submit"
//                   disabled={loading}
//                   style={
//                     loading
//                       ? localCommonStyles.submitButtonDisabledStyle
//                       : localCommonStyles.submitButtonStyle
//                   }
//                 >
//                   {loading ? (
//                     <>
//                       <span
//                         className="spinner-border spinner-border-sm"
//                         style={{ marginRight: "8px" }}
//                       ></span>
//                       Sending...
//                     </>
//                   ) : (
//                     "Send Reset Link"
//                   )}
//                 </Button>
//               </Form>
//               <div style={{ textAlign: "center", marginTop: "25px" }}>
//                 <Button
//                   variant="link"
//                   onClick={() => navigate(-1)}
//                   style={{
//                     color: themeColors.VETRINA_PURPLE,
//                     textDecoration: "none",
//                     fontWeight: "500",
//                     fontSize: "0.9rem",
//                   }}
//                   onMouseOver={(e) =>
//                     (e.target.style.color = themeColors.VETRINA_ORANGE)
//                   }
//                   onMouseOut={(e) =>
//                     (e.target.style.color = themeColors.VETRINA_PURPLE)
//                   }
//                 >
//                   <FaArrowLeft style={{ marginRight: "5px" }} /> Back to Sign In
//                 </Button>
//               </div>
//             </motion.div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// const AuthPage = () => {
//   const [isLoginView, setIsLoginView] = useState(true);
//   const [initialLoading, setInitialLoading] = useState(true);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => setInitialLoading(false), 1200);
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => {
//       clearTimeout(timer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const toggleView = useCallback(() => setIsLoginView((prev) => !prev), []);

//   const handleGoogleAuthSuccess = async (credentialResponse) => {
//     const token = credentialResponse.credential;
//     Swal.fire({
//       title: "Processing Google Sign-In...",
//       didOpen: () => Swal.showLoading(),
//       allowOutsideClick: false,
//       confirmButtonColor: VETRINA_PURPLE,
//       background: VETRINA_BACKGROUND_LIGHT,
//     });
//     try {
//       const response = await axios.post(`${API_BASE_URL}auth/google/login/`, {
//         token,
//       });
//       localStorage.setItem("jwttoken", response.data.access);
//       Swal.close();
//       Swal.fire({
//         title: "Success!",
//         text: "Signed in with Google successfully!",
//         icon: "success",
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//         confirmButtonColor: VETRINA_PURPLE,
//         background: VETRINA_BACKGROUND_LIGHT,
//       }).then(() => navigate("/Home"));
//     } catch (error) {
//       Swal.close();
//       Swal.fire({
//         title: "Error!",
//         text: error.response?.data?.error || "Google sign-in failed.",
//         icon: "error",
//         confirmButtonColor: VETRINA_ORANGE,
//         background: VETRINA_BACKGROUND_LIGHT,
//       });
//     }
//   };

//   const isMobile = windowWidth < 992;

//   if (initialLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//           background: `linear-gradient(135deg, ${VETRINA_ACCENT_LIGHT_PURPLE} 0%, #f0f2f5 100%)`,
//         }}
//       >
//         <Lottie options={defaultLottieOptions} height={120} width={120} />
//         <h3
//           style={{
//             marginTop: 20,
//             color: VETRINA_PURPLE,
//             fontFamily: "'Poppins', sans-serif",
//             fontWeight: "bold",
//           }}
//         >
//           Loading VetLearn...
//         </h3>
//       </div>
//     );
//   }

//   return (
//     <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
//       {/* This is the main page container div */}
//       <div
//         style={{
//           background: "white", // Overall page background is white
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           fontFamily: "'Poppins', sans-serif",
//           position: "relative",
//           overflow: "hidden", // Important for preventing horizontal scroll from background blobs/elements
//         }}
//       >
//         {/* NEW HEADER */}
//         <header
//           style={{
//             height: HEADER_HEIGHT,
//             backgroundColor: "white",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "0 20px",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//             zIndex: 1000, // Increased z-index to ensure it's always on top
//             position: "fixed", // Make the header fixed
//             top: 0,
//             left: 0,
//             right: 0,
//           }}
//         >
//           <div style={{ flexShrink: 0 }}>
//             {/* Left side: Logo */}
//             <img
//               src={VetLearnLogo} // Use VetLearnLogo directly
//               alt="VetLearn Logo"
//               onClick={() => navigate("/")}
//               style={{
//                 height: "2em",
//                 cursor: "pointer",
//                 filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))",
//               }}
//             />
//           </div>

//           <div style={{ textAlign: "center" }}>
//             {!isMobile &&(
//             <motion.h1
//               initial={{ opacity: 0, scale: 0.8 }}
//               animate={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.5, ease: "easeOut" }}
//               style={{
//                 fontSize: "2.2em",
//                 fontWeight: "700",
//                 margin: 0,
//                 fontFamily: "'Poppins', sans-serif",
//                 letterSpacing: "0px", // Needs browser support

//                 background:
//                   "linear-gradient(90deg, #a82682, #a92984, #d46b0c, #a82682)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 backgroundSize: "300% 100%",
//                 animation: "shimmerPublic 5s linear infinite",
//                 textShadow:
//                   "0 0 5px rgba(255,255,255,0.3), 0 0 10px rgba(142, 45, 226, 0.2)",
//               }}
//             >
//               VetLearn Hub
//             </motion.h1>
//             )}
//           </div>

//           <div style={{ display: "flex", gap: "15px", flexShrink: 0 }}>
//             {/* Desktop: Show both buttons */}
//             {!isMobile && (
//               <>
//                 <Button
//                   variant="link"
//                   onClick={() => setIsLoginView(true)}
//                   style={{
//                     color: isLoginView
//                       ? VETRINA_PURPLE
//                       : VETRINA_TEXT_SECONDARY,
//                     fontWeight: isLoginView ? "bold" : "normal",
//                     textDecoration: "none",
//                     fontSize: "0.95rem",
//                     borderBottom: isLoginView
//                       ? `2px solid ${VETRINA_PURPLE}`
//                       : "none",
//                     paddingBottom: "5px",
//                     transition: "all 0.3s ease",
//                   }}
//                   onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
//                   onMouseOut={(e) =>
//                     (e.target.style.color = isLoginView
//                       ? VETRINA_PURPLE
//                       : VETRINA_TEXT_SECONDARY)
//                   }
//                 >
//                   Sign In
//                 </Button>
//                 <Button
//                   variant="link"
//                   onClick={() => setIsLoginView(false)}
//                   style={{
//                     color: !isLoginView
//                       ? VETRINA_PURPLE
//                       : VETRINA_TEXT_SECONDARY,
//                     fontWeight: !isLoginView ? "bold" : "normal",
//                     textDecoration: "none",
//                     fontSize: "0.95rem",
//                     borderBottom: !isLoginView
//                       ? `2px solid ${VETRINA_PURPLE}`
//                       : "none",
//                     paddingBottom: "5px",
//                     transition: "all 0.3s ease",
//                   }}
//                   onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
//                   onMouseOut={(e) =>
//                     (e.target.style.color = !isLoginView
//                       ? VETRINA_PURPLE
//                       : VETRINA_TEXT_SECONDARY)
//                   }
//                 >
//                   Sign Up
//                 </Button>
//               </>
//             )}

//             {/* Mobile: Show only one toggle button */}
//             {isMobile && (
//               <Button
//                 variant="link"
//                 onClick={() => setIsLoginView(!isLoginView)}
//                 style={{
//                   color: VETRINA_PURPLE,
//                   fontWeight: "bold",
//                   textDecoration: "none",
//                   fontSize: "1rem",
//                   borderBottom: `2px solid ${VETRINA_PURPLE}`,
//                   paddingBottom: "5px",
//                   transition: "all 0.3s ease",
//                 }}
//                 onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
//                 onMouseOut={(e) => (e.target.style.color = VETRINA_PURPLE)}
//               >
//                 {isLoginView ? "Sign Up" : "Sign In"}
//               </Button>
//             )}
//           </div>
//         </header>

//         {/* Main Content Area */}
//         <Container
//           fluid
//           style={{
//             flexGrow: 1,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: "0px", // Main container padding
//             paddingTop: HEADER_HEIGHT, // Add padding to push content below the fixed header
//           }}
//         >
//           <Row
//             className="w-100 g-0 justify-content-center align-items-stretch"
//             style={{
//               minHeight: `calc(100vh - ${HEADER_HEIGHT})`, // Ensure row fills remaining viewport height
//             }}
//           >
//             {!isMobile && (
//               <Col
//                 lg={6}
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center", // Center image horizontally within its column if not taking full width
//                   justifyContent: "center", // Center image vertically
//                   padding: "0", // No padding at the Col level, controlled by inner div
//                   overflow: "hidden", // Prevent image from causing scroll
//                 }}
//               >
//                 <motion.div
//                   key={isLoginView ? "loginImagePanel" : "registerImagePanel"}
//                   initial={{ opacity: 0, x: -30 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.7, delay: 0.2 }}
//                   style={{
//                     maxWidth: "900px",
//                     width: "100vw", // Full screen width
//                     textAlign: "left",
//                     flexGrow: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-start",
//                     justifyContent: "center",
//                     paddingLeft: 0, // Remove left padding
//                     paddingRight: 0, // Optional: remove right padding too
//                     margin: 0,
//                   }}
//                 >
//                   <AnimatePresence mode="wait">
//                     <motion.div
//                       key={
//                         isLoginView
//                           ? "loginImageContent"
//                           : "registerImageContent"
//                       }
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       exit={{ opacity: 0 }}
//                       transition={{ duration: 0.4 }}
//                     >
//                       <img
//                         src={isLoginView ? LoginImage : RegisterImage}
//                         alt={
//                           isLoginView
//                             ? "Login Illustration"
//                             : "Registration Illustration"
//                         }
//                         style={{
//                           width: "100%",
//                           height: "auto",
//                           maxHeight: "580px",
//                           objectFit: "contain",
//                           display: "block",
//                           transform: "translateX(-80px)", // 👈 shifts the image 40px left
//                         }}
//                       />
//                     </motion.div>
//                   </AnimatePresence>
//                 </motion.div>
//               </Col>
//             )}

//             <Col
//               xs={12}
//               lg={isMobile ? 12 : 6}
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 // Removed justifyContent: "center" here to allow the form card to flex-grow and scroll
//                 // justifyContent: "center",
//                 padding: isMobile ? "20px" : "20px 20px 20px 15px", // Added 20px top/bottom padding for desktop
//                 background: "rgba(255, 255, 255, 0.0)",
//               }}
//             >
//               {/* Text above the form box */}
//               <motion.p
//                 key={isLoginView ? "loginTagline" : "signupTagline"}
//                 initial={{ opacity: 0, y: -20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: 0.1 }}
//                 style={{
//                   color: "black",
//                   fontSize: isMobile ? "0.75rem" : "1.2rem",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   display: "inline-block",
//                   maxWidth: "100%",
//                   fontWeight: "400",
//                   textAlign: "center",
//                   marginBottom: "15px",
//                   // maxWidth: "500px",
//                   // lineHeight: "1.4",
//                   // padding: "0 15px", // Added internal padding to tagline on smaller screens
//                 }}
//               >
//                 <AnimatePresence mode="wait">
//                   <motion.span
//                     key={
//                       isLoginView ? "loginTaglineText" : "registerTaglineText"
//                     }
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     exit={{ opacity: 0 }}
//                     transition={{ duration: 0.4 }}
//                   >
//                     {isLoginView
//                       ? "Empowering You to Learn, Experience, and Succeed."
//                       : "Explore Possibilities. Gain Experience. Shape Your Future."}
//                   </motion.span>
//                 </AnimatePresence>
//               </motion.p>

//               {/* Form card container - THIS IS WHERE THE SCROLL WILL BE APPLIED */}
//               <motion.div
//                 key={isLoginView ? "loginCard" : "registerCard"}
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6 }}
//                 style={{
//                   backgroundColor: "white",
//                   borderRadius: "16px", // Slightly smaller radius for a tighter look
//                   padding: "45px", // Remove all internal padding
//                   boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)", // Slightly lighter shadow
//                   width: "100%",
//                   maxWidth: "520px",
//                   border: "1px solid rgba(0,0,0,0.05)",
//                   flexGrow: 1,
//                   flexShrink: 1,
//                   maxHeight: "80vh",
//                   overflowY: "auto",
//                   minHeight: 50,
//                 }}
//               >
//                 <div style={{ textAlign: "center", padding: "12px 16px 0" }}>
//                   <motion.h2
//                     key={isLoginView ? "loginTitle" : "registerTitle"}
//                     initial={{ opacity: 0, y: -10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.1, duration: 0.4 }}
//                     style={{
//                       color: VETRINA_PURPLE,
//                       fontSize: isMobile ? "1.2rem" : "1.4rem",
//                       fontWeight: "bold",
//                       marginBottom: "5px",
//                     }}
//                   >
//                     {isLoginView ? "Welcome to Your Learning Space" : "Create Account"}
//                   </motion.h2>
//                   <motion.p
//                     key={isLoginView ? "loginSubTitle" : "registerSubTitle"}
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.2, duration: 0.4 }}
//                     style={{
//                       color: VETRINA_TEXT_SECONDARY,
//                       fontSize: "0.85rem",
//                       marginTop: "5px",
//                     }}
//                   >
//                     {isLoginView
//                       ? "Sign in to continue your learning journey."
//                       : "Join our veterinary community!"}
//                   </motion.p>
//                 </div>
//                 <AnimatePresence mode="wait">
//                   {isLoginView ? (
//                     <motion.div
//                       key="loginFormDiv"
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       exit={{ opacity: 0 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <LoginForm
//                         toggleView={toggleView}
//                         onGoogleSuccess={handleGoogleAuthSuccess}
//                         apiBaseUrl={API_BASE_URL}
//                         themeColors={{
//                           VETRINA_PURPLE,
//                           VETRINA_ORANGE,
//                           VETRINA_DARK_PURPLE_ACCENT,
//                           VETRINA_TEXT_SECONDARY,
//                           VETRINA_BACKGROUND_LIGHT,
//                           VETRINA_TEXT_PRIMARY, // Added for Swal html
//                         }}
//                         commonStyles={{
//                           formControlBaseStyle, // Pass the new base style
//                           inputGroupTextStyle,
//                           inputGroupControlWithinGroupStyle, // Pass the new within-group style
//                           submitButtonStyle,
//                           submitButtonDisabledStyle,
//                         }}
//                       />
//                     </motion.div>
//                   ) : (
//                     <motion.div
//                       key="registerFormDiv"
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       exit={{ opacity: 0 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <RegisterForm
//                         toggleView={toggleView}
//                         onGoogleSuccess={handleGoogleAuthSuccess}
//                         apiBaseUrl={API_BASE_URL}
//                         themeColors={{
//                           VETRINA_PURPLE,
//                           VETRINA_ORANGE,
//                           VETRINA_TEXT_SECONDARY,
//                           VETRINA_BACKGROUND_LIGHT,
//                           VETRINA_ACCENT_LIGHT_PURPLE,
//                         }}
//                         commonStyles={{
//                           formControlBaseStyle, // Pass the new base style
//                           inputGroupTextStyle,
//                           inputGroupControlWithinGroupStyle, // Pass the new within-group style
//                           submitButtonStyle,
//                           submitButtonDisabledStyle,
//                         }}
//                       />
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//                 <p
//                   style={{
//                     textAlign: "center",
//                     marginTop: "15px",
//                     fontSize: "0.75rem",
//                     color: VETRINA_TEXT_SECONDARY,
//                   }}
//                 >
//                   By {isLoginView ? "signing in" : "creating an account"}, you
//                   agree to our{" "}
//                   <a
//                     href="/terms"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ color: VETRINA_PURPLE, textDecoration: "none" }}
//                   >
//                     Terms
//                   </a>{" "}
//                   &{" "}
//                   <a
//                     href="/privacy"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ color: VETRINA_PURPLE, textDecoration: "none" }}
//                   >
//                     Privacy
//                   </a>
//                   .
//                 </p>
//               </motion.div>
//             </Col>
//           </Row>
//         </Container>
//         <div>
//            <motion.div>
//           At VetLearn, your growth is our priority. This platform is built to support your journey in
// becoming a confident, skilled, and knowledgeable professional in the field of animal
// healthcare and nutrition.
//  </motion.div>
//         </div>

//         {/* Enhanced Background Animation */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             overflow: "hidden",
//             pointerEvents: "none",
//             zIndex: 0,
//           }}
//         >
//           {[...Array(8)].map((_, i) => (
//             <motion.div
//               key={i}
//               initial={{
//                 x: Math.random() * window.innerWidth,
//                 y: Math.random() * window.innerHeight,
//                 scale: 0.3 + Math.random() * 0.4,
//                 opacity: 0.05 + Math.random() * 0.1,
//               }}
//               animate={{
//                 x: Math.random() * window.innerWidth,
//                 y: Math.random() * window.innerHeight,
//                 rotate: 360,
//               }}
//               transition={{
//                 duration: 15 + Math.random() * 20,
//                 repeat: Number.POSITIVE_INFINITY,
//                 repeatType: "mirror",
//                 ease: "easeInOut",
//               }}
//               style={{
//                 position: "absolute",
//                 width: 100 + Math.random() * 150,
//                 height: 100 + Math.random() * 150,
//                 borderRadius: "50%",
//                 background:
//                   i % 3 === 0
//                     ? `radial-gradient(circle, ${VETRINA_PURPLE}20 0%, transparent 70%)`
//                     : i % 3 === 1
//                     ? `radial-gradient(circle, ${VETRINA_ORANGE}15 0%, transparent 70%)`
//                     : `radial-gradient(circle, #4A90E2 10 0%, transparent 70%)`,
//                 filter: "blur(20px)",
//               }}
//             />
//           ))}
//         </div>

//         {/* Custom PhoneInput and General Styles */}
//         <style>{`
//           /* Universal reset for html/body/root to ensure 100vh works without default margins */
//           html, body, #root {
//             margin: 0;
//             padding: 0;
//             height: 100%;
//             overflow: hidden; /* This is the ultimate guard against PAGE scrolling */
//           }

//           /* PhoneInput specific styles */
//           .PhoneInput {
//             display: flex;
//             width: 100%;
//           }
//           .PhoneInputCountry {
//             background-color: ${VETRINA_ACCENT_LIGHT_PURPLE};
//             border: 1px solid ${VETRINA_PURPLE}; /* Purple border */
//             border-right: none; /* Seamless merge */
//             border-top-left-radius: 8px;
//             border-bottom-left-radius: 8px;
//             border-top-right-radius: 0; /* Flat to merge */
//             border-bottom-right-radius: 0; /* Flat to merge */
//             color: ${VETRINA_PURPLE};
//             padding: 0 12px;
//             display: flex;
//             align-items: center;
//             min-width: 45px;
//             height: 50px; /* Consistent height */
//             margin: 0; /* No external margins */
//             outline: none; /* No outline on focus */
//           }
//           .PhoneInputCountrySelect {
//             background: transparent;
//             border: none;
//             height: 100%;
//             width: 100%;
//             font-size: 0.9rem;
//             color: ${VETRINA_PURPLE}; /* Ensure text is visible */
//             -webkit-appearance: none;
//             -moz-appearance: none;
//             appearance: none;
//             cursor: pointer;
//             padding-right: 20px; /* Make space for arrow */
//           }
//           .PhoneInputCountrySelect option {
//             color: ${VETRINA_TEXT_PRIMARY}; /* Ensure options are visible */
//           }
//           .PhoneInputCountrySelect:focus {
//             outline: none;
//             box-shadow: none;
//           }
//           .PhoneInputCountrySelectArrow {
//             color: ${VETRINA_PURPLE};
//             position: absolute; /* positioned relative to .PhoneInputCountry */
//             right: 5px;
//             pointer-events: none;
//             top: 50%;
//             transform: translateY(-50%);
//           }
//           .PhoneInputInput {
//             border: 1px solid ${VETRINA_PURPLE}; /* Now purple */
//             padding: 0px 12px;
//             height: 50px; /* Consistent height */
//             border-top-right-radius: 8px; /* Rounded on the right end */
//             border-bottom-right-radius: 8px; /* Rounded on the right end */
//             border-top-left-radius: 0; /* Flat to merge */
//             border-bottom-left-radius: 0; /* Flat to merge */
//             border-left: none; /* Seamless merge */
//             font-size: 0.9rem;
//             flex-grow: 1;
//             margin: 0; /* No external margins */
//           }
//           /* Focus styles for the entire PhoneInput compound component */
//           .PhoneInput.PhoneInput--focus .PhoneInputCountry,
//           .PhoneInput.PhoneInput--focus .PhoneInputInput {
//             border-color: ${VETRINA_PURPLE} !important; /* Keep purple border on focus */
//             box-shadow: 0 0 0 0.25rem ${VETRINA_ACCENT_LIGHT_PURPLE} !important;
//           }
//           /* Override default Bootstrap focus for any .form-control inside PhoneInput */
//           .PhoneInput .form-control:focus {
//             border-color: ${VETRINA_PURPLE} !important;
//             box-shadow: 0 0 0 0.25rem ${VETRINA_ACCENT_LIGHT_PURPLE} !important;
//           }

//           /* General Bootstrap input overrides */
//           .form-control:focus {
//             border-color: ${VETRINA_PURPLE} !important;
//             box-shadow: 0 0 0 0.25rem ${VETRINA_ACCENT_LIGHT_PURPLE} !important;
//           }
//           /* This is for the InputGroup.Text element itself, outside PhoneInput, ensure it inherits common styles */
//           .input-group-text {
//             height: 50px; /* Ensure consistency with inputs */
//             font-size: 0.9rem;
//             border-top-left-radius: 8px; /* Make sure these are applied */
//             border-bottom-left-radius: 8px;
//             border-top-right-radius: 0; /* Flat for merging */
//             border-bottom-right-radius: 0;
//             border: 1px solid ${VETRINA_PURPLE}; /* Explicit purple border */
//             border-right: none; /* No right border for merging */
//           }

//           /* Adjust Google button size for consistency */
//           .g_id_signin div {
//              width: 100% !important;
//              justify-content: center !important;
//              min-height: 40px !important;
//              border-radius: 20px !important;
//           }
//           .g_id_signin div > div:first-child {
//              padding: 0 12px !important;
//           }
//           .g_id_signin div > div:last-child {
//              flex-grow: 1;
//              text-align: center !important;
//              padding: 0 10px !important;
//           }

//           /* SweetAlert2 custom styling for consistency across all modals */
//           .swal2-popup {
//             border-radius: 15px !important;
//             font-family: 'Poppins', sans-serif !important;
//           }
//           .swal2-title {
//             color: ${VETRINA_PURPLE} !important;
//             font-size: 1.5em !important;
//           }
//           .swal2-html-container {
//             color: ${VETRINA_TEXT_SECONDARY} !important;
//             font-size: 1em !important;
//           }
//           .swal2-confirm {
//             background-color: ${VETRINA_PURPLE} !important;
//             border-color: ${VETRINA_PURPLE} !important;
//           }
//           .swal2-error .swal2-confirm {
//             background-color: ${VETRINA_ORANGE} !important;
//             border-color: ${VETRINA_ORANGE} !important;
//           }
//           @keyframes shimmerPublic {
//             0% { background-position: 0% 50%; }
//             100% { background-position: 100% 50%; }
//           }
//         `}</style>
//       </div>{" "}
//       {/* Closes the main page container div */}
//     </GoogleOAuthProvider>
//   );
// };

// export default AuthPage;

import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import VetLearnLogo from "../Images/Vetrina _Logo.png"; // Ensure this path is correct
import RegisterImage from "../Images/TestLogin1.png"; // Ensure this path is correct
import LoginImage from "../Images/TestLogin1.png"; // Ensure this path is correct
import { motion, AnimatePresence } from "framer-motion";
import Lottie from "react-lottie";

// Vetrina Theme Colors
const VETRINA_PURPLE = "#B8529E";
const VETRINA_ORANGE = "#FF6600";
const VETRINA_TEXT_PRIMARY = "#333";
const VETRINA_TEXT_SECONDARY = "#555";
const VETRINA_BACKGROUND_LIGHT = "#f8f9fa";
const VETRINA_ACCENT_LIGHT_PURPLE = "#ede7f6";
const VETRINA_DARK_PURPLE_ACCENT = "#7D52A0";

// API Configuration
const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com/";

// Lottie Animation
const loadingAnimationData = {
  v: "5.5.7", fr: 30, ip: 0, op: 60, w: 100, h: 100, nm: "Loading", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Circle", sr: 1, ks: { o: { a: 0, k: 100 }, r: { a: 1, k: [{ t: 0, s: [0], e: [360] }, { t: 60, s: [360], e: [720] }] }, p: { a: 0, k: [50, 50, 0] }, a: { a: 0, k: [0, 0, 0] }, s: { a: 0, k: [100, 100, 100] } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [40, 40] }, p: { a: 0, k: [0, 0] }, nm: "Ellipse Path 1" }, { ty: "st", c: { a: 0, k: [0.72, 0.32, 0.62, 1] }, o: { a: 0, k: 100 }, w: { a: 0, k: 6 }, lc: 2, lj: 1, ml: 4, bm: 0, nm: "Stroke 1" }, { ty: "tr", p: { a: 0, k: [0, 0] }, a: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] }, r: { a: 0, k: 0 }, o: { a: 0, k: 100 }, nm: "Transform" }], nm: "Ellipse 1" }], ip: 0, op: 60, st: 0, bm: 0 }],
};
const defaultLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingAnimationData,
  rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
};

// Header Height Constant
const HEADER_HEIGHT = "60px";

// Common Styles
const formControlBaseStyle = {
  border: `1px solid ${VETRINA_PURPLE}`,
  padding: "8px 12px",
  height: "48px",
  fontSize: "0.9rem",
};
const inputGroupTextStyle = {
  backgroundColor: VETRINA_ACCENT_LIGHT_PURPLE,
  border: `1px solid ${VETRINA_PURPLE}`,
  borderRight: "none",
  borderTopLeftRadius: "8px",
  borderBottomLeftRadius: "8px",
  color: VETRINA_PURPLE,
  padding: "0 12px",
  display: "flex",
  alignItems: "center",
  height: "48px",
};
const inputGroupControlWithinGroupStyle = {
  ...formControlBaseStyle,
  borderLeft: "none",
  borderTopLeftRadius: "0",
  borderBottomLeftRadius: "0",
};
const submitButtonStyle = {
  background: `linear-gradient(45deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE})`,
  borderColor: "transparent",
  fontSize: "1rem",
  padding: "10px",
  marginTop: "10px",
  marginBottom: "10px",
  height: "42px",
  borderRadius: "10px",
  fontWeight: "bold",
  boxShadow: `0 4px 15px rgba(184, 82, 158, 0.3)`,
  width: "100%",
  transition: "all 0.3s ease",
};
const submitButtonDisabledStyle = {
  ...submitButtonStyle,
  background: VETRINA_DARK_PURPLE_ACCENT,
  cursor: "default",
};

const LoginForm = ({ toggleView, apiBaseUrl, themeColors, commonStyles }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isErr, setIsErr] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
  

    const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
    useEffect(() => {
      const savedEmail = localStorage.getItem("savedEmail");
      if (savedEmail) {
        setEmail(savedEmail);
        setRememberMe(true);
      }
    }, []);
  
    const loginUser = async (e) => {
      e.preventDefault();
      setLoading(true);
      setIsErr(false);
      try {
        const response = await axios.post(`${apiBaseUrl}auth/login/`, { email, password });
        if (response.data && response.status === 200) {
          const token = response.data.access;
const decoded = parseJwt(token);
if (decoded?.user_id) {
  localStorage.setItem("userId", decoded.user_id);
}
          if (rememberMe) localStorage.setItem("savedEmail", email);
          else localStorage.removeItem("savedEmail");
          localStorage.setItem("jwttoken", response.data.access);

          const role = response.data.role;
          if (role) localStorage.setItem("role", role);
          const roleMapper = {
            Client: "/result",
            Trainer: "/result",
            Instructor: "/Home",
            Admin: "/lmsadmindashboard",
          };
          const targetPath = roleMapper[role] || "/Home";
          Swal.fire({
            title: "Success!",
            text: "You have logged in successfully.",
            icon: "success",
            background: VETRINA_BACKGROUND_LIGHT,
            confirmButtonColor: themeColors.VETRINA_PURPLE,
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then(() => navigate(targetPath));
        }
      } catch (error) {
        const errMessage = error.response?.data?.error || error.response?.data?.detail || "Invalid Credentials or server error.";
        Swal.fire({
          title: "Login Failed!",
          text: errMessage,
          icon: "error",
          background: VETRINA_BACKGROUND_LIGHT,
          confirmButtonColor: themeColors.VETRINA_ORANGE,
          confirmButtonText: "Try Again",
        });
        setIsErr(true);
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <Form onSubmit={loginUser}>
        <Form.Group className="mb-2">
          <InputGroup>
            <InputGroup.Text style={{ ...commonStyles.inputGroupTextStyle, borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE }}>
              <FaEnvelope />
            </InputGroup.Text>
            <Form.Control type="email" placeholder="Email Address" value={email} onChange={(e) => { setIsErr(false); setEmail(e.target.value); }} required style={{ ...commonStyles.inputGroupControlWithinGroupStyle, borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE, borderTopRightRadius: "8px", borderBottomRightRadius: "8px" }} />
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-2">
          <InputGroup>
            <InputGroup.Text style={{ ...commonStyles.inputGroupTextStyle, borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE }}>
              <FaLock />
            </InputGroup.Text>
            <Form.Control type={showPassword ? "text" : "password"} placeholder="Password" value={password} onChange={(e) => { setIsErr(false); setPassword(e.target.value); }} required style={{ ...commonStyles.inputGroupControlWithinGroupStyle, borderRight: "none", borderColor: isErr ? "#e74c3c" : themeColors.VETRINA_PURPLE, borderTopRightRadius: "0", borderBottomRightRadius: "0" }} />
            <Button onClick={() => setShowPassword(!showPassword)} variant="outline-secondary" style={{ height: commonStyles.inputGroupControlWithinGroupStyle.height, borderColor: themeColors.VETRINA_PURPLE, borderLeft: "none", borderTopRightRadius: "8px", borderBottomRightRadius: "8px", color: themeColors.VETRINA_PURPLE, padding: "0 12px" }}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </Button>
          </InputGroup>
        </Form.Group>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", marginTop: "5px" }}>
          <Form.Check type="checkbox" id="rememberMe" label="Remember me" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} style={{ fontSize: "0.8rem", color: themeColors.VETRINA_TEXT_SECONDARY }} />
          <a href="#!" onClick={(e) => { e.preventDefault(); navigate("/reset-password"); }} style={{ color: themeColors.VETRINA_PURPLE, textDecoration: "none", fontSize: "0.8rem", fontWeight: "500" }}>
            Forgot Password?
          </a>
        </div>
        <Button type="submit" disabled={loading} style={loading ? commonStyles.submitButtonDisabledStyle : commonStyles.submitButtonStyle}>
          {loading ? (<><span className="spinner-border spinner-border-sm" style={{ marginRight: "8px" }}></span>Signing In...</>) : ("Sign In")}
        </Button>
        <p style={{ textAlign: "center", marginTop: "10px", fontSize: "0.85rem", color: themeColors.VETRINA_TEXT_PRIMARY, marginBottom: 0 }}>
          New to VetLearn?
          <a href="#!" onClick={(e) => { e.preventDefault(); toggleView(); }} style={{ color: themeColors.VETRINA_PURPLE, textDecoration: "none", fontWeight: "bold" }}>
            Create Account
          </a>
        </p>
      </Form>
    );
};
  
const RegisterForm = ({ toggleView, apiBaseUrl, themeColors, commonStyles }) => {
    const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", phoneNumber: "", password: "", confirmPassword: "", otp: "" });
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showOTPField, setShowOTPField] = useState(false);
    const [isEmailVerifiedStepDone, setIsEmailVerifiedStepDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((p) => ({ ...p, [name]: value }));
      if (name === "email") validateEmail(value);
      if (name === "confirmPassword") validatePasswords(formData.password, value);
      if (name === "password") validatePasswords(value, formData.confirmPassword);
    };
    const validateEmail = (email) => { /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) ? setEmailError("") : setEmailError("Invalid email format."); };
    const validatePasswords = (pw, cpw) => { cpw && pw !== cpw ? setPasswordError("Passwords do not match.") : setPasswordError(""); };
    const handlePhoneChange = (value) => setFormData((p) => ({ ...p, phoneNumber: value }));
  
    const sendOTP = () => {
      if (!formData.email || emailError) {
        Swal.fire({ title: "Error", text: "Valid email required.", icon: "error", confirmButtonColor: themeColors.VETRINA_ORANGE });
        return;
      }
      setOtpLoading(true);
      axios.post(`${apiBaseUrl}auth/verify-email/`, { email: formData.email })
        .then(() => {
          Swal.fire({ title: "OTP Sent", text: "Check email for OTP.", icon: "success", confirmButtonColor: themeColors.VETRINA_PURPLE });
          setShowOTPField(true);
          setIsEmailVerifiedStepDone(true);
        })
        .catch(() => Swal.fire({ title: "Error", text: "Failed to send OTP.", icon: "error", confirmButtonColor: themeColors.VETRINA_ORANGE }))
        .finally(() => setOtpLoading(false));
    };
  
    const handleRegisterSubmit = async (e) => {
      e.preventDefault();
      const { firstName, lastName, phoneNumber, email, password, confirmPassword, otp } = formData;
      if (!firstName || !lastName || !phoneNumber || !email || !password || !confirmPassword || (showOTPField && !otp) || !isEmailVerifiedStepDone || password !== confirmPassword || password.length < 6) {
        Swal.fire({ text: "Please fill all fields correctly and verify your email.", icon: "error", confirmButtonColor: themeColors.VETRINA_ORANGE });
        return;
      }
      setLoading(true);
      try {
        await axios.post(`${apiBaseUrl}auth/signup/`, {
          email: formData.email,
          password: formData.password,
          first_name: formData.firstName,
          last_name: formData.lastName,
          mobile_number: formData.phoneNumber,
          otp: Number.parseInt(formData.otp),
        });
        Swal.fire({ title: "Success!", text: "Account created! Please log in.", icon: "success", confirmButtonColor: themeColors.VETRINA_PURPLE });
        toggleView();
      } catch (err) {
        const msg = err.response?.data?.detail || err.response?.data?.email?.[0] || err.response?.data?.mobile_number?.[0] || err.response?.data?.otp?.[0] || "Registration failed.";
        Swal.fire({ title: "Error", text: msg, icon: "error", confirmButtonColor: themeColors.VETRINA_ORANGE });
      } finally {
        setLoading(false);
      }
    };
    
  
    return (
      <Form onSubmit={handleRegisterSubmit}>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2">
              <InputGroup>
                <InputGroup.Text style={commonStyles.inputGroupTextStyle}><FaUser /></InputGroup.Text>
                <Form.Control type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required style={commonStyles.inputGroupControlWithinGroupStyle} />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2">
              <InputGroup>
                <InputGroup.Text style={commonStyles.inputGroupTextStyle}><FaUser /></InputGroup.Text>
                <Form.Control type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required style={commonStyles.inputGroupControlWithinGroupStyle} />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-2">
          <InputGroup>
            <InputGroup.Text style={commonStyles.inputGroupTextStyle}><FaEnvelope /></InputGroup.Text>
            <Form.Control type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} isInvalid={!!emailError} required style={{ ...commonStyles.inputGroupControlWithinGroupStyle, borderRight: "none", borderTopRightRadius: "0", borderBottomRightRadius: "0" }} />
            <Button onClick={sendOTP} disabled={otpLoading || !formData.email || !!emailError} style={{ backgroundColor: themeColors.VETRINA_PURPLE, borderColor: themeColors.VETRINA_PURPLE, height: commonStyles.inputGroupControlWithinGroupStyle.height, borderTopRightRadius: "8px", borderBottomRightRadius: "8px", fontSize: "0.8rem", padding: "0 10px" }}>
              {otpLoading ? (<><span className="spinner-border spinner-border-sm" style={{ marginRight: "5px" }}></span>Sending</>) : ("Verify")}
            </Button>
          </InputGroup>
          {emailError && (<Form.Control.Feedback type="invalid" style={{ display: "block" }}>{emailError}</Form.Control.Feedback>)}
        </Form.Group>
        <Form.Group className="mb-2">
          <PhoneInput international defaultCountry="IN" value={formData.phoneNumber} onChange={handlePhoneChange} inputComponent={Form.Control} inputProps={{ name: "phoneNumber", required: true, placeholder: "Phone Number" }} />
        </Form.Group>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2">
              <InputGroup>
                <InputGroup.Text style={commonStyles.inputGroupTextStyle}><FaLock /></InputGroup.Text>
                <Form.Control type={showPassword ? "text" : "password"} name="password" placeholder="Password" value={formData.password} onChange={handleChange} required style={{ ...commonStyles.inputGroupControlWithinGroupStyle, borderRight: "none" }} />
                <Button onClick={() => setShowPassword(!showPassword)} variant="outline-secondary" style={{ height: commonStyles.inputGroupControlWithinGroupStyle.height, borderColor: themeColors.VETRINA_PURPLE, borderLeft: "none", borderTopRightRadius: "8px", borderBottomRightRadius: "8px", color: themeColors.VETRINA_PURPLE, padding: "0 12px" }}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2">
              <InputGroup>
                <InputGroup.Text style={commonStyles.inputGroupTextStyle}><FaLock /></InputGroup.Text>
                <Form.Control type={showConfirmPassword ? "text" : "password"} name="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} isInvalid={!!passwordError} required style={{ ...commonStyles.inputGroupControlWithinGroupStyle, borderRight: "none" }} />
                <Button onClick={() => setShowConfirmPassword(!showConfirmPassword)} variant="outline-secondary" style={{ height: commonStyles.inputGroupControlWithinGroupStyle.height, borderColor: themeColors.VETRINA_PURPLE, borderLeft: "none", borderTopRightRadius: "8px", borderBottomRightRadius: "8px", color: themeColors.VETRINA_PURPLE, padding: "0 12px" }}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
              {passwordError && (<Form.Control.Feedback type="invalid" style={{ display: "block" }}>{passwordError}</Form.Control.Feedback>)}
            </Form.Group>
          </Col>
        </Row>
        {showOTPField && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} transition={{ duration: 0.3 }}>
            <Form.Group className="mb-2">
              <Form.Control type="text" name="otp" value={formData.otp} onChange={handleChange} required style={commonStyles.formControlBaseStyle} placeholder="Enter OTP" />
            </Form.Group>
          </motion.div>
        )}
        <Button type="submit" disabled={loading} style={{ ...commonStyles.submitButtonStyle, width: "100%" }}>
          {loading ? (<><span className="spinner-border spinner-border-sm" style={{ marginRight: "8px" }}></span>Creating...</>) : ("Sign Up")}
        </Button>
        <p style={{ textAlign: "center", marginTop: "10px", fontSize: "0.85rem", color: themeColors.VETRINA_TEXT_PRIMARY, marginBottom: 0 }}>
          Already have an account?
          <a href="#!" onClick={(e) => { e.preventDefault(); toggleView(); }} style={{ color: themeColors.VETRINA_PURPLE, textDecoration: "none", fontWeight: "bold" }}>
            Sign In
          </a>
        </p>
      </Form>
    );
};


const AuthPage = () => {
  const [isLoginView, setIsLoginView] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setInitialLoading(false), 1200);
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleView = useCallback(() => setIsLoginView((prev) => !prev), []);
  const isMobile = windowWidth < 992;

  if (initialLoading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", background: `linear-gradient(135deg, ${VETRINA_ACCENT_LIGHT_PURPLE} 0%, #f0f2f5 100%)` }}>
        <Lottie options={defaultLottieOptions} height={120} width={120} />
        <h3 style={{ marginTop: 20, color: VETRINA_PURPLE, fontFamily: "'Arial', sans-serif", fontWeight: "bold" }}>
          Loading VetLearn...
        </h3>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "white", fontFamily: "'Arial', sans-serif", overflow: "hidden" }}>
      <header style={{ height: HEADER_HEIGHT, backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", zIndex: 10, flexShrink: 0 }}>
        <div style={{ flexShrink: 0 }}>
          <img src={VetLearnLogo} alt="VetLearn Logo" onClick={() => navigate("/")} style={{ height: "2em", cursor: "pointer" }} />
        </div>
        <div style={{ textAlign: "center" }}>
          {!isMobile && (
            <motion.h1 initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, ease: "easeOut" }} style={{ fontSize: "2.2em", fontWeight: "700", margin: 0, fontFamily: "'Arial', sans-serif", background: "linear-gradient(90deg, #a82682, #a92984, #d46b0c, #a82682)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundSize: "300% 100%", animation: "shimmerPublic 5s linear infinite" }}>
              VetLearn Hub
            </motion.h1>
          )}
        </div>
        <div style={{ display: "flex", gap: "15px", flexShrink: 0 }}>
          {!isMobile ? (
            <>
              <Button variant="link" onClick={() => setIsLoginView(true)} style={{ color: isLoginView ? VETRINA_PURPLE : VETRINA_TEXT_SECONDARY, fontWeight: isLoginView ? "bold" : "normal", textDecoration: "none", fontSize: "0.95rem", borderBottom: isLoginView ? `2px solid ${VETRINA_PURPLE}` : "none", paddingBottom: "5px" }}>
                Sign In
              </Button>
              <Button variant="link" onClick={() => setIsLoginView(false)} style={{ color: !isLoginView ? VETRINA_PURPLE : VETRINA_TEXT_SECONDARY, fontWeight: !isLoginView ? "bold" : "normal", textDecoration: "none", fontSize: "0.95rem", borderBottom: !isLoginView ? `2px solid ${VETRINA_PURPLE}` : "none", paddingBottom: "5px" }}>
                Sign Up
              </Button>
            </>
          ) : (
            <Button variant="link" onClick={() => setIsLoginView(!isLoginView)} style={{ color: VETRINA_PURPLE, fontWeight: "bold", textDecoration: "none", fontSize: "1rem" }}>
              {isLoginView ? "Sign Up" : "Sign In"}
            </Button>
          )}
        </div>
      </header>

      <div style={{ flexGrow: 1, display: "flex", position: "relative" }}>
        <Container fluid className="h-100 p-0">
          <Row className="h-100 g-0 align-items-center">
            {!isMobile && (
              <Col lg={6} className="h-100 p-0">
                {/* MODIFICATION: Removed AnimatePresence and key from the image div. */}
                {/* It now animates in once on page load and remains static afterward. */}
                <motion.div
                  style={{
                    width: "100%",
                    height: "100%",
                    // Since LoginImage and RegisterImage are the same, we can just use one.
                    backgroundImage: `url(${LoginImage})`,
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    backgroundRepeat: "no-repeat",
                  }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.7, ease: "easeInOut" }}
                />
              </Col>
            )}

            <Col xs={12} lg={6} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "15px" }}>
                <motion.p initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} style={{ color: "black", fontSize: isMobile ? "0.9rem" : "1.1rem", fontWeight: "400", textAlign: "center", marginBottom: "15px", flexShrink: 0 }}>
                  <AnimatePresence mode="wait">
                    <motion.span key={isLoginView ? "loginTagText" : "regTagText"} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}>
                      {isLoginView ? "Empowering You to Learn, Experience, and Succeed." : "Explore Possibilities. Gain Experience. Shape Your Future."}
                    </motion.span>
                  </AnimatePresence>
                </motion.p>
                <AnimatePresence mode="wait">
                  {isLoginView ? (
                    <motion.div key="loginCard" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }} style={{ backgroundColor: "white", borderRadius: "16px", padding: "20px 25px", boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)", width: "100%", maxWidth: "500px", border: "1px solid rgba(0,0,0,0.05)", flexShrink: 0 }}>
                      <div style={{ textAlign: "center", marginBottom: "15px" }}>
                        <h2 style={{ color: VETRINA_PURPLE, fontSize: isMobile ? "1.2rem" : "1.4rem", fontWeight: "bold", marginBottom: "5px" }}>
                          Welcome to Your Learning Space
                        </h2>
                        <p style={{ color: VETRINA_TEXT_SECONDARY, fontSize: "0.85rem", marginTop: "5px", marginBottom: 0 }}>
                          Sign in to continue your journey.
                        </p>
                      </div>
                      <LoginForm toggleView={toggleView} apiBaseUrl={API_BASE_URL} themeColors={{ VETRINA_PURPLE, VETRINA_ORANGE, VETRINA_DARK_PURPLE_ACCENT, VETRINA_TEXT_SECONDARY, VETRINA_BACKGROUND_LIGHT, }} commonStyles={{ formControlBaseStyle, inputGroupTextStyle, inputGroupControlWithinGroupStyle, submitButtonStyle, submitButtonDisabledStyle, }} />
                    </motion.div>
                  ) : (
                    <motion.div key="registerCard" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }} style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "16px", boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)", width: "100%", maxWidth: "500px", border: "1px solid rgba(0,0,0,0.05)", flexShrink: 0, maxHeight: "calc(100vh - 220px)", overflowY: "auto" }}>
                      <div style={{ textAlign: "center", padding: "20px 25px 15px 25px", flexShrink: 0 }}>
                        <h2 style={{ color: VETRINA_PURPLE, fontSize: isMobile ? "1.2rem" : "1.4rem", fontWeight: "bold", marginBottom: "5px" }}>
                          Create Your Account
                        </h2>
                        <p style={{ color: VETRINA_TEXT_SECONDARY, fontSize: "0.85rem", marginTop: "5px", marginBottom: 0 }}>
                          Join our veterinary community!
                        </p>
                      </div>
                      <div style={{ flexGrow: 1, padding: "0 25px 20px 25px" }}>
                        <RegisterForm toggleView={toggleView} apiBaseUrl={API_BASE_URL} themeColors={{ VETRINA_PURPLE, VETRINA_ORANGE, VETRINA_TEXT_SECONDARY, VETRINA_BACKGROUND_LIGHT, VETRINA_ACCENT_LIGHT_PURPLE, }} commonStyles={{ formControlBaseStyle, inputGroupTextStyle, inputGroupControlWithinGroupStyle, submitButtonStyle, submitButtonDisabledStyle, }} />
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} style={{ maxWidth: "500px", width: "100%", marginTop: "20px", textAlign: "justify", color: "#000", fontSize: "1rem", lineHeight: "1.5", flexShrink: 0 }}>
                  At VetLearn, your growth is our priority. This platform is
                  built to support your journey in becoming a confident,
                  skilled, and knowledgeable professional in the field of
                  animal healthcare and nutrition.
                </motion.div>
            </Col>
          </Row>
        </Container>
      </div>

      <style>{`
          html, body, #root { margin: 0; padding: 0; height: 100%; overflow: hidden; }
          ::placeholder { color: #999 !important; font-size: 0.7rem !important; opacity: 1; }
          :-ms-input-placeholder { color: #999 !important; font-size: 0.8rem !important; }
          ::-ms-input-placeholder { color: #999 !important; font-size: 0.8rem !important; }
          .PhoneInput { display: flex; width: 100%; align-items: stretch; }
          .PhoneInputCountry { background-color: ${VETRINA_ACCENT_LIGHT_PURPLE}; border: 1px solid ${VETRINA_PURPLE}; border-right: none; border-top-left-radius: 8px; border-bottom-left-radius: 8px; color: ${VETRINA_PURPLE}; padding: 0 10px; display: flex; align-items: center; height: 48px; }
          .PhoneInputInput { border: 1px solid ${VETRINA_PURPLE}; padding: 8px 12px; height: 48px; font-size: 0.9rem; flex-grow: 1; margin: 0; border-left: none; border-top-left-radius: 0; border-bottom-left-radius: 0; border-top-right-radius: 8px; border-bottom-right-radius: 8px; }
          .PhoneInput.PhoneInput--focus .PhoneInputCountry, .PhoneInput.PhoneInput--focus .PhoneInputInput, .form-control:focus { border-color: ${VETRINA_PURPLE} !important; box-shadow: 0 0 0 0.25rem ${VETRINA_ACCENT_LIGHT_PURPLE} !important; }
          .input-group-text { height: 48px; }
          .swal2-popup { border-radius: 15px !important; font-family: 'Arial', sans-serif !important; }
          .swal2-title { color: ${VETRINA_PURPLE} !important; }
          .swal2-html-container { color: ${VETRINA_TEXT_SECONDARY} !important; }
          @keyframes shimmerPublic { 0% { background-position: 0% 50%; } 100% { background-position: 100% 50%; } }
      `}</style>
    </div>
  );
};

export default AuthPage;